import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  AccessTimeOutlined,
  Add,
  CreditCardOutlined,
  InfoOutlined,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  ReceiptLongOutlined,
  EventNoteOutlined,
  ScheduleOutlined,
  CalendarViewWeekOutlined,
  CancelOutlined,
  CategoryOutlined,
} from "@mui/icons-material";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import messages from "../../../../assets/locale/messages";
import { getCurranciesLookUpRequest } from "../../../../store/LookUps/actions";
import {
  deleteBranchServiceRequest,
  deleteBranchSpecialtyRequest,
  editBranchRequest,
  editBranchServicesRequest,
  getBranchRequest,
  getBranchResponse,
  getBranchServicesRequest,
  getRequestStatus,
  getServicesRequest,
  getServicesResponse,
  getSpecialtiesRequest,
  getSpecialtiesResponse,
  getPublishBranchServiceRequestStatus,
  getDeleteBranchSpecialityStatusRequest,
  getDeleteBranchServiceStatusRequest,
} from "../../../../store/Branches/actions";
import { getGoogleMapsPolygon } from "../../../../store/GoogleMapCoords/actions";
import Modal from "../../../../components/Modal";
import Input from "../../../../components/Input";
import Switch from "../../../../components/Switch";
import Select from "../../../../components/Select";
import Button from "../../../../components/Button";
import Checkbox from "../../../../components/Checkbox";
import Accordion from "../../../../components/Accordion";
import EmptyState from "../../../../components/EmptyState";
import Tooltip from "../../../../components/Tooltip";
import AddEditManualSpecialtyModal from "./ManualSpecialtyOrServiceManagment/AddEditManualSpecialtyModal";
import DeleteManualAddedSpecialtyModal from "./ManualSpecialtyOrServiceManagment/DeleteManualAddedSpecialtyModal";
import AddEditManualServiceModal from "./ManualSpecialtyOrServiceManagment/AddEditManualServiceModal";
import DeleteManualAddedServiceModal from "./ManualSpecialtyOrServiceManagment/DeleteManualAddedServiceModal";
import { EditBgIcon } from "../../../../utils/Icons/EditBg";
import {
  ONE_NUMBERS_ONLY,
  TWO_DICIMAL_ONLY,
  ONLY_ENGLISH_SPACE_DOT_COMMA_SEMICOLON,
  ONLY_ARABIC_SPACE_DOT_COMMA_SEMICOLON,
  NUMBERS_REGEX,
} from "../../../../utils/Patterns";
import { ROUTE_PATHS } from "../../../../utils/RoutesPaths";
import { DeleteBgIcon } from "../../../../utils/Icons/DeleteBg";
import { renderTextEllipsis } from "../../../../utils/Helpers";

import "./AddEditServicesDetails.scss";

const AddEditServicesDetails = ({
  changeSubTitle,
  renderList,
  changeServiceTitle,
  proceedToNextStep,
  btnClicked,
  ressetBtnClicked,
  backToPrevStep,
  parentProps,
  removeMainAddBtn,
  setBtnClicked,
}) => {
  const lang = useSelector((state) => state.locale.lang);
  const { branches, shared, inputsValidations } = messages[lang];
  const history = useHistory();
  const { providerid } = useParams();
  const { id } = useParams();
  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state.loader);
  const specialtiesList = useSelector(
    (state) => state.branches.addEditViewBranch.specialties.specialtiesList.list
  );
  const serviceslist = useSelector(
    (state) => state.branches.addEditViewBranch.services.servicesList.list
  );
  const currencyOptions = useSelector((state) => state.lookUps.currancies);
  const viewBranchDetails = useSelector(
    (state) => state.branches.addEditViewBranch.branchDetails
  ); // get branch detauls by id original BE data
  const branchServicesList = useSelector(
    (state) => state.branches.addEditViewBranch.helpers.branchServices
  );
  const requestStatus = useSelector(
    (state) => state.branches.addEditViewBranch.requestStatus
  );
  const publishBranchServiceStatusRequest = useSelector(
    (state) => state.branches.publishBranchServiceStatusRequest
  );
  const deleteBranchServiceStatusRequest = useSelector(
    (state) => state.branches.deleteBranchServiceStatusRequest
  );
  const deleteBranchSpecialityStatusRequest = useSelector(
    (state) => state.branches.deleteBranchSpecialityStatusRequest
  );
  const savedBranchCreatedId = useSelector(
    (state) => state.branches.addEditViewBranch.helpers.branchCreatedId
  );
  // Get category from branchDetails, profileDetails, or auth.login to check allowMultiSessions
  const branchCategory = useSelector(
    (state) => state.branches.addEditViewBranch.branchDetails?.category
  );
  const profileDetails = useSelector((state) => state.profileDetails.myProfile);
  const authLogin = useSelector((state) => state.auth?.login);
  const category = branchCategory || profileDetails?.category || authLogin?.category;
  const allowMultiSessions = category?.is_multi_session_allowed || false;

  const [mappedServices, setMappedServices] = useState([]);
  const [nativeServices, setNativeServices] = useState(null);
  const [deleteServiceId, setdeleteServiceId] = useState(null);
  const [deleteSpecialtyId, setdeleteSpecialtyId] = useState(null);
  const [choosenSpecialtyId, setChoosenSpecialtyId] = useState(null);
  const [currencyOptionsList, setCurrencyOptionsList] = useState(null);
  const [renderServicesSection, setRenderServicesSection] = useState(false);
  const [showLeaveWarningModal, setShowLeaveWarningModal] = useState(false);
  const [renderEmpatyStateSection, setRenderEmpatyStateSection] =
    useState(false);
  const [renderAddedServiceSection, setRenderAddedServiceSection] =
    useState(false);
  const [renderSpecialtiesSection, setRenderSpecialtiesSection] =
    useState(false);
  const [openDeleteSpecilatyConfirm, setOpenDeleteSepecialtyConfirm] =
    useState(false);
  const [openDeleteServiceConfirm, setOpenDeleteServiceConfirm] =
    useState(false);
  const [addedSepacialtyWithServices, setAddedSepacialtyWithServices] =
    useState(null);
  const [
    noAssgiendServicesOnSpecialtyAlert,
    setNoAssgiendServicesOnSpecialtyAlert,
  ] = useState(false);
  const [
    isAddSpecialtiesAndServicesBTNClicked,
    setIsAddSpecialtiesAndServicesBTNClicked,
  ] = useState(false);
  const [serviceTitle, setServiceTitle] = useState(null);
  const [servicesStatus, setServicesStatus] = useState([]);
  const [showDeactivateServicePopup, setShowDeactivateServicePopup] =
    useState(false);
  const [deactivatedService, setDeactivatedService] = useState({});
  const [openDoneModal, setOpenDoneModal] = useState(false);
  const [showAddEditManualSpecialtyModal, setShowAddEditManualSpecialtyModal] =
    useState(false);
  const [
    showDeleteManualAddedSpecialtyModal,
    setShowDeleteManualAddedSpecialtyModal,
  ] = useState(false);
  const [selectedManualAddedSpecialty, setSelectedManualAddedSpecialty] =
    useState(null);
  const [showAddEditManualServiceModal, setShowAddEditManualServiceModal] =
    useState(false);
  const [
    showDeleteManualAddedServiceModal,
    setShowDeleteManualAddedServiceModal,
  ] = useState(false);
  const [selectedManualAddedService, setSelectedManualAddedService] =
    useState(null);
  const branchCreatedId =
    savedBranchCreatedId || history.location?.state?.branchCreatedId;

  const setActiveSection = (section) => {
    setRenderEmpatyStateSection(section === "empty");
    setRenderSpecialtiesSection(section === "specialties");
    setRenderServicesSection(section === "services");
    setRenderAddedServiceSection(section === "added");
  };

  useEffect(() => {
    dispatch(getCurranciesLookUpRequest());
    // dispatch(getSpecialtiesResponse([]));
    dispatch(getRequestStatus(null));
    dispatch(getGoogleMapsPolygon([]));
  }, []);

  useEffect(() => {
    return () => {
      dispatch(getSpecialtiesResponse([]));
    };
  }, []);

  useEffect(() => {
    if (publishBranchServiceStatusRequest != null) {
      dispatch(
        getBranchServicesRequest({
          page: -1,
          branch_id: viewBranchDetails?.id,
        })
      );
    }
    dispatch(getPublishBranchServiceRequestStatus(null));
  }, [publishBranchServiceStatusRequest]);

  useEffect(() => {
    if (deleteBranchServiceStatusRequest) {
      dispatch(
        getBranchServicesRequest({
          page: -1,
          branch_id: viewBranchDetails?.id,
        })
      );
      dispatch(
        getBranchRequest(
          branchCreatedId || parentProps?.location?.state?.branchDataToEdit?.id
        )
      );
    }
  }, [deleteBranchServiceStatusRequest]);

  useEffect(() => {
    if (deleteBranchSpecialityStatusRequest) {
      dispatch(
        getBranchRequest(
          branchCreatedId || parentProps?.location?.state?.branchDataToEdit?.id
        )
      );
    }
  }, [deleteBranchSpecialityStatusRequest]);

  const errorss = [
    {
      errorTitle: "currencyIsRequired",
      errorMessaged:
        branches.addBranch.specialtiesAndServices.currencyIsRequired,
    },
    {
      errorTitle: "onlyNumbersAreAllowed",
      errorMessaged:
        branches.addBranch.specialtiesAndServices.onlyNumbersAreAllowed,
    },
    {
      errorTitle: "fromIsRequired",
      errorMessaged: branches.addBranch.specialtiesAndServices.fromIsRequired,
    },
    {
      errorTitle: "feesIsRequired",
      errorMessaged: branches.addBranch.specialtiesAndServices.feesIsRequired || "Fees is required",
    },
    {
      errorTitle: "durationIsRequired",
      errorMessaged:
        branches.addBranch.specialtiesAndServices.durationIsRequired,
    },
    {
      errorTitle: "durationCanNotBeLessThanOne",
      errorMessaged:
        branches.addBranch.specialtiesAndServices.durationCanNotBeLessThanOne,
    },
    {
      errorTitle: "onlyEnglishSpaceDotCommaSemicolon",
      errorMessaged:
        branches.addBranch.specialtiesAndServices
          .onlyEnglishSpaceDotCommaSemicolon,
    },
    {
      errorTitle: "onlyArabicSpaceDotCommaSemicolon",
      errorMessaged:
        branches.addBranch.specialtiesAndServices
          .onlyArabicSpaceDotCommaSemicolon,
    },
    {
      errorTitle: "minimumSessionsRequired",
      errorMessaged:
        branches.addBranch.specialtiesAndServices.minimumSessionsRequired,
    },
    {
      errorTitle: "fieldRequired",
      errorMessaged: inputsValidations.required,
    },
    {
      errorTitle: "currencyFieldRequired",
      errorMessaged: inputsValidations.required,
    },
    {
      errorTitle: "durationFieldRequired",
      errorMessaged: inputsValidations.required,
    },
    {
      errorTitle: "expiryWeeksFieldRequired",
      errorMessaged: inputsValidations.required,
    },
    {
      errorTitle: "scheduleTypeFieldRequired",
      errorMessaged: inputsValidations.required,
    },
    {
      errorTitle: "cancellationWindowFieldRequired",
      errorMessaged: inputsValidations.required,
    },
  ];

  useEffect(() => {
    if (currencyOptions?.length > 0) {
      let mappedCurrencyOptions = currencyOptions.map((item) => {
        return {
          // add space before name_ar as select component crop first letter in local ar
          label: lang === "en" ? item.name_en : ` ${item.name_ar}`,
          value: item.id,
          id: item.id,
        };
      });
      setCurrencyOptionsList(mappedCurrencyOptions);
    }
  }, [currencyOptions, lang]);

  useEffect(() => {
    if (renderServicesSection && choosenSpecialtyId !== null) {
      getServicesBySpecialtyId(choosenSpecialtyId);
    }
  }, [choosenSpecialtyId, renderServicesSection]);

  useEffect(() => {
    if (renderAddedServiceSection) {
      dispatch(
        getBranchRequest(
          branchCreatedId || parentProps?.location?.state?.branchDataToEdit?.id
        )
      );
    }
  }, [renderAddedServiceSection]);

  useEffect(() => {
    setTimeout(() => {
      renderServicesContent();
    }, 500);
  }, [
    viewBranchDetails,
    choosenSpecialtyId,
    renderServicesSection,
    serviceslist,
  ]);

  useEffect(() => {
    assignAddedSpecialtyAndServicesFromViewBranchData();
  }, [lang, viewBranchDetails]);

  useEffect(() => {
    checkSetctionToRender();
  }, [viewBranchDetails]);

  // to update accordion
  useEffect(() => {
    // TODO: add branch service list to depandanced array
    updateAccordionData();
  }, [
    branchServicesList,
    currencyOptionsList,
    lang,
    deleteServiceId,
    serviceslist,
    publishBranchServiceStatusRequest,
  ]);

  useEffect(() => {
    if (specialtiesList?.length > 0) {
      checkSetctionToRender();
      setIsAddSpecialtiesAndServicesBTNClicked(false);
    } else {
      if (isAddSpecialtiesAndServicesBTNClicked) {
        setRenderSpecialtiesSection(true);
        setRenderEmpatyStateSection(false);
      }
    }
  }, [specialtiesList]);

  useEffect(() => {
    if (
      addedSepacialtyWithServices?.length > 0 &&
      specialtiesList?.length > 0
    ) {
      setAddedSepacialtyWithServices(
        addedSepacialtyWithServices?.map((specialty) => {
          specialtiesList?.forEach((item) => {
            if (item.title === specialty.specialtyName) {
              specialty.realSpecialtyId = item.id;
            }
          });
          return specialty;
        })
      );
    }
  }, [specialtiesList]);

  useEffect(() => {
    if (renderServicesSection || renderSpecialtiesSection) {
      if (serviceTitle) {
        changeServiceTitle(
          lang === "en" ? serviceTitle.name_en : serviceTitle.name_ar
        );
      }
    }
  }, [lang, renderServicesSection]);

  useEffect(() => {
    if (btnClicked) {
      checkSectionToRenderBtnClicked();
      setTimeout(() => {
        ressetBtnClicked();
      }, 1000);
    }
  }, [btnClicked]);

  useEffect(() => {
    removeMainAddBtn(renderEmpatyStateSection);
  }, [renderEmpatyStateSection]);

  useEffect(() => {
    showAddedServicesAfterSave();
  }, [requestStatus]);

  useEffect(() => {
    if (addedSepacialtyWithServices?.length === 0) {
      removeMainAddBtn(true);
    } else {
      removeMainAddBtn(false);
    }
  }, [addedSepacialtyWithServices]);

  const assignAddedSpecialtyAndServicesFromViewBranchData = () => {
    let mappedarray = [];
    if (viewBranchDetails?.specialties?.length > 0) {
      viewBranchDetails.specialties?.map((item) => {
        let specialty = {
          id: null,
          specialtyName: "",
          isExpanded: false,
          realSpecialtyId: null,
          services: [],
        };
        specialty = {
          ...specialty,
          id: item.id,
          specialtyName:
            lang === "en" ? item.specialty_title_en : item.specialty_title_ar,
          specialty_title_en: item.specialty_title_en,
          specialty_title_ar: item.specialty_title_ar,
          realSpecialtyId: item.specialty_id,
        };
        mappedarray.push(specialty);
        return item;
      });
    }
    setAddedSepacialtyWithServices(mappedarray);
  };
  const updateAccordionData = () => {
    if (branchServicesList?.length > 0) {
      const branchServiceStatus = branchServicesList.map((service) => {
        return {
          service_id: service.service_id,
          isPublished: service.status === "published" ? true : false,
        };
      });
      setServicesStatus(branchServiceStatus);
      let newAddedSepacialtyWithServices = addedSepacialtyWithServices?.map(
        (specialty) => {
          let services = branchServicesList?.filter(
            (branchService) =>
              branchService.branch_specialty_id === specialty.id
          );
          if (services?.length > 0) {
            services?.forEach((singleService) => {
              let service = {
                id: singleService.id,
                service_id: singleService.service_id,
                name_en: singleService.title_en,
                name_ar: singleService.title_ar,
                service_type: singleService.service_type || "single_service",
                sessions_count: singleService.sessions_count ? String(singleService.sessions_count) : "",
                expiry_weeks: singleService.expiry_weeks ? String(singleService.expiry_weeks) : "",
                schedule_type: singleService.schedule_type || null,
                cancellation_window_hours: singleService.cancellation_window_hours ? String(singleService.cancellation_window_hours) : "",
                currency_id: singleService.currency_id,
                details: {
                  feesRange: {
                    from: singleService.fees_from,
                    to: singleService.fees_to,
                    hasErrors: false,
                    errors: [],
                  },
                  currency: currencyOptionsList?.find(
                    (currency) =>
                      currency.id === singleService.currency_id ||
                      currency.id === 1
                  ),
                  duration: singleService.duration_mins,
                  // description: lang === 'en' ? singleService.description_en : singleService.description_ar,
                  descriptionEN: {
                    value: singleService.description_en || "",
                    hasErrors: false,
                    errors: [],
                  },
                  descriptionAR: {
                    value: singleService.description_ar || "",
                    hasErrors: false,
                    errors: [],
                  },
                  hasErrors: false,
                  errors: [],
                },
                _destroy: false,
                editMood: false,
                isActive: singleService.is_active,
              };
              if (specialty.id === singleService.branch_specialty_id) {
                if (specialty.services?.length === 0) {
                  specialty.services.push(service);
                } else {
                  let isServiceExists = specialty.services?.findIndex(
                    (item) => item.id === singleService.id
                  );
                  if (isServiceExists === -1) {
                    specialty.services.push(service);
                  }
                }
              }
            });
          }

          return specialty;
        }
      );
      setAddedSepacialtyWithServices(newAddedSepacialtyWithServices);
    }
  };

  const clearServicesState = () => {
    dispatch(getServicesResponse({ list: [] }));
  };

  const {
    values,
    setFieldValue,
    setValues,
    handleSubmit,
    touched,
    errors,
    setFieldTouched,
    dirty,
    isValid,
    resetForm,
  } = useFormik({
    initialValues: {
      choosenServices: [],
    },
    validationSchema: Yup.object({
      choosenServices: Yup.array().of(
        Yup.object().shape({
          serviceId: Yup.number(),
          details: Yup.object().shape({
            feesRange: Yup.object().shape({
              from: Yup.number(),
              to: Yup.number(),
            }),
            currency: Yup.object().shape({
              label: Yup.string(),
              value: Yup.number(),
              id: Yup.number(),
            }),
            duration: Yup.number(),
            // description: Yup.string(),
            descriptionEN: Yup.string(),
            descriptionAR: Yup.string(),
          }),
        })
      ),
    }),
    onSubmit: (obj) => {},
  });

  useEffect(() => {
    if (!renderServicesSection && renderAddedServiceSection && values?.choosenServices?.length > 0) {
      setAddedSepacialtyWithServices((prevServices) =>
        prevServices.map((specialty) => {
          return {
            ...specialty,
            services: specialty.services?.map((service) => {
              const updatedService = values.choosenServices.find(
                (s) => s.serviceId === service.service_id || s.serviceId === service.id
              );
              if (updatedService && updatedService.isChoosen) {
                return {
                  ...service,
                  details: {
                    ...service.details,
                    feesRange: {
                      ...service.details.feesRange,
                      from: updatedService.details?.feesRange?.from ?? service.details.feesRange.from,
                      to: updatedService.details?.feesRange?.to ?? service.details.feesRange.to,
                    },
                    currency: updatedService.details?.currency ?? service.details.currency,
                    duration: updatedService.details?.duration ?? service.details.duration,
                    descriptionEN: updatedService.details?.descriptionEN ?? service.details.descriptionEN,
                    descriptionAR: updatedService.details?.descriptionAR ?? service.details.descriptionAR,
                  },
                };
              }
              return service;
            }),
          };
        })
      );
    }
  }, [renderServicesSection, renderAddedServiceSection, values.choosenServices]);

  const checkSetctionToRender = () => {
    if (!btnClicked) {
      if (viewBranchDetails) {
        if (viewBranchDetails?.specialties?.length > 0) {
          setActiveSection("added");
          changeSubTitle(null);
        } else {
          setActiveSection("empty");
          changeSubTitle(null);
          changeServiceTitle(null);
        }
      } else {
        if (specialtiesList && specialtiesList?.length > 0) {
          setActiveSection("specialties");
          changeSubTitle("AddSpecialties");
        } else {
          setActiveSection("empty");
          changeSubTitle(null);
          changeServiceTitle(null);
        }
      }
    }
  };

  const checkSectionToRenderBtnClicked = () => {
    if (btnClicked === "list") {
      if (addedSepacialtyWithServices?.length > 0) {
        setRenderAddedServiceSection(true);
        setRenderEmpatyStateSection(false);
        setRenderServicesSection(false);
        setRenderSpecialtiesSection(false);
        changeSubTitle("AddedServices");
      } else {
        setRenderAddedServiceSection(true);
        setRenderEmpatyStateSection(false);
        setRenderServicesSection(false);
        setRenderSpecialtiesSection(false);
        changeSubTitle(null);
      }
      setIsAddSpecialtiesAndServicesBTNClicked(false);
    } else if (btnClicked === "listSpecialties") {
      getSpecialties();
      dispatch(
        getBranchServicesRequest({
          page: -1,
          branch_id: viewBranchDetails?.id,
        })
      );
      setRenderAddedServiceSection(false);
      setServiceTitle(null);
      changeServiceTitle(null);
      setRenderEmpatyStateSection(false);
      setRenderServicesSection(false);
      setRenderSpecialtiesSection(true);
      changeSubTitle("AddSpecialties");
      setIsAddSpecialtiesAndServicesBTNClicked(true);
    }
  };

  const renderServicesContent = () => {
    if (serviceslist?.length === 0) {
      setNoAssgiendServicesOnSpecialtyAlert(true);
    } else {
      setNoAssgiendServicesOnSpecialtyAlert(false);
    }
    const servicesListMapped = serviceslist?.map((service, i) => {
      return {
        serviceId: service.id,
        relatedSpecialtyId: service?.specialty?.id,
        name_en: service.title_en,
        name_ar: service.title_ar,
        status: service.status,
        rejection_reason: service.rejection_reason,
        service_type: service.service_type || "single_service",
        sessions_count: service.sessions_count ? String(service.sessions_count) : "",
        expiry_weeks: service.expiry_weeks ? String(service.expiry_weeks) : "",
        schedule_type: service.schedule_type || null,
        cancellation_window_hours: service.cancellation_window_hours ? String(service.cancellation_window_hours) : "",
        isChoosen: false,
        details: {
          feesRange: {
            from: "",
            to: "",
            hasErrors: false,
            errors: [],
          },
          currency: null,
          duration: "",
          // description: '',
          descriptionEN: {
            value: "",
            hasErrors: false,
            errors: [],
          },
          descriptionAR: {
            value: "",
            hasErrors: false,
            errors: [],
          },
          hasErrors: false,
          errors: [],
        },
      };
    });
    setMappedServices(servicesListMapped);
    if (viewBranchDetails?.specialties?.length > 0) {
      setNativeServices(viewBranchDetails.specialties);
    }
    if (addedSepacialtyWithServices?.length > 0) {
      const newMappedServices = servicesListMapped.map((service) => {
        const targerSpecialty = addedSepacialtyWithServices.find((elt) => {
          return elt.realSpecialtyId === service.relatedSpecialtyId;
        });
        const ServiceFound = targerSpecialty?.services?.find(
          (x) => x.service_id === service.serviceId
        );
        let serviceCopy = {
          ...service,
          id: service.id,
          service_id: service.service_id,
          isChoosen: false,
          details: {
            feesRange: {
              from: "",
              to: "",
              hasErrors: false,
              errors: [],
            },
            currency: null,
            duration: "",
            // description: '',
            descriptionEN: {
              value: "",
              hasErrors: false,
              errors: [],
            },
            descriptionAR: {
              value: "",
              hasErrors: false,
              errors: [],
            },
            hasErrors: false,
            errors: [],
          },
        };
        if (ServiceFound) {
          serviceCopy.isChoosen = true;
          serviceCopy.id = ServiceFound.id;
          serviceCopy.service_id = service.service_id;
          serviceCopy.service_type = ServiceFound.service_type || "single_service";
          serviceCopy.sessions_count = ServiceFound.sessions_count ? String(ServiceFound.sessions_count) : "";
          serviceCopy.expiry_weeks = ServiceFound.expiry_weeks ? String(ServiceFound.expiry_weeks) : "";
          serviceCopy.schedule_type = ServiceFound.schedule_type || null;
          serviceCopy.cancellation_window_hours = ServiceFound.cancellation_window_hours ? String(ServiceFound.cancellation_window_hours) : "";
          serviceCopy.details = {
            ...ServiceFound.details,
            currency: currencyOptionsList?.find(
              (currency) =>
                currency.id === ServiceFound.currency_id || currency.id === 1
            ),
            duration: ServiceFound.details.duration,
            // description: ServiceFound.details.description,
            descriptionEN: ServiceFound.details.descriptionEN,
            descriptionAR: ServiceFound.details.descriptionAR,
            feesRange: {
              from: ServiceFound.details.feesRange.from,
              to: ServiceFound.details.feesRange.to,
              hasErrors: false,
              errors: [],
            },
          };
        }
        return serviceCopy;
      });
      setFieldValue("choosenServices", newMappedServices);
    } else {
      setFieldValue("choosenServices", [...servicesListMapped]);
    }
  };

  const updateServicesContent = () => {
    setFieldValue("choosenServices", []);
    setMappedServices([]);
    const servicesListMapped = serviceslist?.map((service, i) => {
      return {
        serviceId: service.id,
        name_en: service.title_en,
        name_ar: service.title_ar,
        service_type: service.service_type || "single_service",
        sessions_count: service.sessions_count || "",
        expiry_weeks: service.expiry_weeks || "",
        schedule_type: service.schedule_type || null,
        cancellation_window_hours: service.cancellation_window_hours || "",
        isChoosen: false,
        details: {
          feesRange: {
            from: "",
            to: "",
            hasErrors: false,
            errors: [],
          },
          currency: null,
          duration: "",
          // description: '',
          descriptionEN: {
            value: "",
            hasErrors: false,
            errors: [],
          },
          descriptionAR: {
            value: "",
            hasErrors: false,
            errors: [],
          },
          hasErrors: false,
          errors: [],
        },
      };
    });
    setFieldValue("choosenServices", servicesListMapped);
    setMappedServices(servicesListMapped);
    if (viewBranchDetails?.specialties?.length > 0) {
      setNativeServices(viewBranchDetails.specialties);
      if (addedSepacialtyWithServices?.length > 0) {
        addedSepacialtyWithServices.forEach((addedSepacialty) => {
          if (addedSepacialty.services.length > 0) {
            addedSepacialty.services.forEach((service) => {
              setFieldValue(
                "choosenServices",
                values["choosenServices"]?.map((choosenService) => {
                  if (choosenService.name_en === service.name_en) {
                    choosenService.isChoosen = true;
                    choosenService.service_id = service.service_id;
                    choosenService.id = service.id;
                    choosenService.service_type = service.service_type || "single_service";
                    choosenService.sessions_count = service.sessions_count || "";
                    choosenService.expiry_weeks = service.expiry_weeks || "";
                    choosenService.schedule_type = service.schedule_type || null;
                    choosenService.cancellation_window_hours = service.cancellation_window_hours || "";
                    choosenService.details.feesRange.from =
                      service.details.feesRange.from;
                    choosenService.details.feesRange.to =
                      service.details.feesRange.to;
                    choosenService.details.currency = currencyOptionsList?.find(
                      (currency) =>
                        currency.id === service.currency_id || currency.id === 1
                    );
                    choosenService.details.duration = service.details.duration;
                    // choosenService.details.description = service.details.description;
                    choosenService.details.descriptionEN.value =
                      service.details.descriptionEN.value || "";
                    choosenService.details.descriptionAR.value =
                      service.details.descriptionAR.value || "";
                  }
                  return choosenService;
                })
              );
            });
          } else {
            dispatch(
              getBranchServicesRequest({
                page: -1,
                branch_id: viewBranchDetails?.id,
              })
            );
          }
        });
      }
    }
  };

  const handleExpandFuntion = (isExpanded, id) => {
    if (isExpanded) {
      dispatch(
        getBranchServicesRequest({
          page: -1,
          branch_id: viewBranchDetails?.id,
        })
      );
    }
  };

  const getSpecialties = () => {
    dispatch(
      getSpecialtiesRequest({
        page: -1,
        service_provider_id: providerid,
      })
    );
  };

  const getServicesBySpecialtyId = (specialtyId) => {
    dispatch(
      getServicesRequest({
        specialty_id: specialtyId,
      })
    );
  };

  const handleToggleButtonValue = (serviceId) => {
    const targetService = servicesStatus.find(
      (service) => service.service_id === serviceId
    );
    return targetService?.isPublished;
  };

  const handleActivateOrDeactivateService = (service) => {
    dispatch(
      editBranchServicesRequest({
        id: service.id,
        data: {
          status: handleToggleButtonValue(service.service_id)
            ? "unpublished"
            : "published",
        },
      })
    );
    setAddedSepacialtyWithServices(
      addedSepacialtyWithServices.map((specialty) => {
        specialty.services?.map((mappedService) => {
          if (mappedService.id === service?.id) {
            service.status = handleToggleButtonValue(service.service_id)
              ? "unpublished"
              : "published";
          }
          return mappedService;
        });
        return specialty;
      })
    );
  };

  const handleConfirmDecativateService = () => {
    handleActivateOrDeactivateService(deactivatedService);
    handleCloseDeactivatePopup();
  };

  const handleCloseDeactivatePopup = () => {
    setShowDeactivateServicePopup(false);
    setDeactivatedService({});
  };

  const renderEmptyState = () => {
    return (
      !isLoading && (
        <div className="bg-white rounded-4 services-page d-flex justify-content-center align-items-center flex-column m-4 mt-0">
          <EmptyState
            subTitle={shared.noServicesAddedyet}
            ButtonLabel={branches.addBranch.labels.addSepicialtiesAndServices}
            handleBtnAction={() => {
              dispatch(getBranchResponse({}));
              getSpecialties();
              setNoAssgiendServicesOnSpecialtyAlert(false);
              setIsAddSpecialtiesAndServicesBTNClicked(true);
            }}
          />
        </div>
      )
    );
  };

  const renderSpecialties = () => {
    return (
      !isLoading && (
        <>
          {specialtiesList?.length > 0 ? (
            <div>
              {specialtiesList?.map((specialty, index) => {
                return (
                  <div key={specialty.id}>
                    <div
                      className="d-flex justify-content-between align-items-center pointer"
                      onClick={() => {
                        clearServicesState();
                        setChoosenSpecialtyId(specialty.id);
                        setActiveSection("services");
                        changeSubTitle("AddSpecialties");
                        changeServiceTitle(
                          lang === "en" ? specialty.name_en : specialty.name_ar
                        );
                      }}
                    >
                      <p className="text-gray fsize-16 mb-0 text-break">
                        {renderTextEllipsis(
                          lang === "en" ? specialty.name_en : specialty.name_ar,
                          40
                        )}
                      </p>
                      {specialty.status === "pending" ||
                      specialty.status === "rejected" ? (
                        <div className="d-flex align-items-center gap-2">
                          <EditBgIcon
                            width={26}
                            height={26}
                            onClick={(e) => {
                              e.stopPropagation();
                              e.preventDefault();
                              setSelectedManualAddedSpecialty(specialty);
                              setShowAddEditManualSpecialtyModal(true);
                            }}
                          />
                          <DeleteBgIcon
                            width={26}
                            height={26}
                            onClick={(e) => {
                              e.stopPropagation();
                              e.preventDefault();
                              setSelectedManualAddedSpecialty(specialty);
                              setShowDeleteManualAddedSpecialtyModal(true);
                            }}
                          />
                          <Tooltip
                            title={
                              <span className="fsize-12">
                                {
                                  branches.addBranch.specialtiesAndServices
                                    .addedSpecialtyInfo
                                }
                              </span>
                            }
                            content={
                              <span
                                className="text-bg-primary-mid fsize-14 font-reguler"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  e.preventDefault();
                                }}
                              >
                                {specialty.status === "rejected" ? (
                                  <PriorityHighIcon
                                    size={26}
                                    style={{ color: "#DC4D2A" }}
                                  />
                                ) : (
                                  <InfoOutlined
                                    size={26}
                                    style={{ color: "#D19985" }}
                                  />
                                )}
                              </span>
                            }
                          />
                          <div className="arrow-bg">
                            {lang === "en" ? (
                              <KeyboardArrowRight />
                            ) : (
                              <KeyboardArrowLeft />
                            )}
                          </div>
                        </div>
                      ) : (
                        <div className="arrow-bg">
                          {lang === "en" ? (
                            <KeyboardArrowRight />
                          ) : (
                            <KeyboardArrowLeft />
                          )}
                        </div>
                      )}
                    </div>
                    {/* {index !== specialtiesList?.length - 1 && <div className="line-separator"></div>} */}
                    <div className="line-separator"></div>
                    {index === specialtiesList?.length - 1 && (
                      <div
                        className="d-flex align-items-center text-secondary pointer"
                        onClick={() => {
                          setShowAddEditManualSpecialtyModal(true);
                          setSelectedManualAddedSpecialty(null);
                        }}
                      >
                        <Add />
                        {
                          branches.addBranch.specialtiesAndServices
                            .createNewSpecialty
                        }
                        <Tooltip
                          title={
                            <span className="fsize-12">
                              {
                                branches.addBranch.specialtiesAndServices
                                  .createNewSpecialtyInfo
                              }
                            </span>
                          }
                          content={
                            <span className="text-bg-primary-mid fsize-14 font-reguler">
                              <InfoOutlined
                                size={26}
                                style={{ color: "#D19985" }}
                              />
                            </span>
                          }
                        />
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          ) : (
            <>
              <div className="bg-white rounded-4 services-page d-flex justify-content-center align-items-center flex-column m-4 mt-0">
                <EmptyState
                  subTitle={shared.noSpecialtiesOnCategoryyet}
                  showActionButton={true}
                  ButtonLabel={
                    <span className="d-flex align-items-center gap-2">
                      {
                        branches.addBranch.specialtiesAndServices
                          .createNewSpecialty
                      }
                      <Tooltip
                        title={
                          <span className="fsize-12">
                            {
                              branches.addBranch.specialtiesAndServices
                                .createNewSpecialtyInfo
                            }
                          </span>
                        }
                        content={
                          <span className="text-bg-primary-mid fsize-14 font-reguler">
                            <InfoOutlined
                              size={26}
                              style={{ color: "white" }}
                            />
                          </span>
                        }
                      />
                    </span>
                  }
                  handleBtnAction={() => {
                    setShowAddEditManualSpecialtyModal(true);
                    setSelectedManualAddedSpecialty(null);
                  }}
                />
              </div>
            </>
          )}
        </>
      )
    );
  };
  const handleCloseShowLeaveWarningModal = () => {
    setShowLeaveWarningModal(false);
  };

  const handleConfirmShowLeaveWarning = () => {
    setServiceTitle(null);
    changeSubTitle(null);
    changeServiceTitle(null);
    setRenderServicesSection(false);
    setRenderAddedServiceSection(false);
    setShowLeaveWarningModal(false);
    setRenderAddedServiceSection(true);
  };

  const showAddedServicesAfterSave = () => {
    if (requestStatus) {
      // Sync form data back to display state before clearing
      if (values?.choosenServices?.length > 0) {
        setAddedSepacialtyWithServices((prevServices) =>
          prevServices.map((specialty) => {
            return {
              ...specialty,
              services: specialty.services?.map((service) => {
                const updatedService = values.choosenServices.find(
                  (s) => s.serviceId === service.service_id || s.serviceId === service.id
                );
                if (updatedService && updatedService.isChoosen) {
                  return {
                    ...service,
                    details: {
                      ...service.details,
                      feesRange: {
                        ...service.details.feesRange,
                        from: updatedService.details?.feesRange?.from ?? service.details.feesRange.from,
                        to: updatedService.details?.feesRange?.to ?? service.details.feesRange.to,
                      },
                      currency: updatedService.details?.currency ?? service.details.currency,
                      duration: updatedService.details?.duration ?? service.details.duration,
                      descriptionEN: updatedService.details?.descriptionEN ?? service.details.descriptionEN,
                      descriptionAR: updatedService.details?.descriptionAR ?? service.details.descriptionAR,
                    },
                  };
                }
                return service;
              }),
            };
          })
        );
      }

      setRenderSpecialtiesSection(false);
      changeSubTitle(null);
      changeSubTitle(null);
      setRenderEmpatyStateSection(false);
      setRenderServicesSection(false);
      setRenderAddedServiceSection(true);
      const branchId = branchCreatedId || parentProps?.location?.state?.branchDataToEdit?.id;
      if (branchId) {
        dispatch(getBranchRequest(branchId));
        dispatch(
          getBranchServicesRequest({
            page: -1,
            branch_id: branchId,
          })
        );
      }
      setFieldValue("choosenServices", []);
      setMappedServices([]);
      ressetBtnClicked();
      dispatch(getRequestStatus(false));
    }
  };

  const isEditSpecialtySaveBtnDisabled = () => {
    // disable if no service is choosen or choosen sevice without the required data
    const selectedServices = values["choosenServices"]?.filter(
      (item) => item.isChoosen
    );
    const hasSelectedServicesWithoutRequiredData = values[
      "choosenServices"
    ]?.some((item) => {
      if (!item.isChoosen) {
        return false;
      }
      
      // Basic required fields
      if (
        !item.details?.duration ||
        item.details?.duration === "" ||
        !item.details?.currency ||
        !item.details?.feesRange?.from ||
        item.details?.feesRange?.from === ""
      ) {
        return true;
      }
      
      // Validate multi-session fields if applicable
      if (allowMultiSessions && item.service_type === "multi_session") {
        // All multi-session fields are required for multi_session type
        if (
          !item.sessions_count ||
          item.sessions_count === "" ||
          !item.expiry_weeks ||
          item.expiry_weeks === "" ||
          !item.schedule_type ||
          !item.cancellation_window_hours ||
          item.cancellation_window_hours === ""
        ) {
          return true;
        }
        
        // Sessions count must be >= 2
        const sessionsCount = parseInt(item.sessions_count, 10);
        if (isNaN(sessionsCount) || sessionsCount < 2) {
          return true;
        }
        
        // Expiry weeks must be > 0 (positive integer)
        const expiryWeeks = parseInt(item.expiry_weeks, 10);
        if (isNaN(expiryWeeks) || expiryWeeks <= 0) {
          return true;
        }
        
        // Cancellation window hours must be > 0
        const cancellationHours = parseInt(item.cancellation_window_hours, 10);
        if (isNaN(cancellationHours) || cancellationHours <= 0) {
          return true;
        }
      } else if (allowMultiSessions && (item.sessions_count || item.expiry_weeks || item.schedule_type)) {
        // If service has any multi-session fields but is not explicitly multi_session, validate them if they exist
        if (item.sessions_count && item.sessions_count !== "") {
          const sessionsCount = parseInt(item.sessions_count, 10);
          if (isNaN(sessionsCount) || sessionsCount < 2) {
            return true;
          }
        }

        if (item.expiry_weeks && item.expiry_weeks !== "") {
          const expiryWeeks = parseInt(item.expiry_weeks, 10);
          if (isNaN(expiryWeeks) || expiryWeeks <= 0) {
            return true;
          }
        }

        if (item.cancellation_window_hours && item.cancellation_window_hours !== "") {
          const cancellationHours = parseInt(item.cancellation_window_hours, 10);
          if (isNaN(cancellationHours) || cancellationHours <= 0) {
            return true;
          }
        }
      }

      // For single services, cancellation_window_hours is always required
      if (item.service_type !== "multi_session") {
        if (!item.cancellation_window_hours || item.cancellation_window_hours === "") {
          return true;
        }
        const cancellationHours = parseInt(item.cancellation_window_hours, 10);
        if (isNaN(cancellationHours) || cancellationHours <= 0) {
          return true;
        }
      }

      return false;
    });
    return !selectedServices.length || hasSelectedServicesWithoutRequiredData;
  };

  const isEditServiceSaveBtnDisabled = (specialtyId, serviceId) => {
    // disable if the service missing any required data
    const specialty = addedSepacialtyWithServices?.find(
      (item) => item.id === specialtyId
    );
    const service = specialty?.services?.find((item) => item.id === serviceId);
    
    if (!service) {
      return true;
    }
    
    // Basic required fields
    if (
      !service.details?.duration ||
      service.details?.duration === "" ||
      !service.details?.currency ||
      !service.details?.feesRange?.from ||
      service.details?.feesRange?.from === ""
    ) {
      return true;
    }
    
    // Validate multi-session fields if applicable
    if (allowMultiSessions && service.service_type === "multi_session") {
      // All multi-session fields are required for multi_session type
      if (
        !service.sessions_count ||
        service.sessions_count === "" ||
        !service.expiry_weeks ||
        service.expiry_weeks === "" ||
        !service.schedule_type ||
        !service.cancellation_window_hours ||
        service.cancellation_window_hours === ""
      ) {
        return true;
      }
      
      // Sessions count must be >= 2
      const sessionsCount = parseInt(service.sessions_count, 10);
      if (isNaN(sessionsCount) || sessionsCount < 2) {
        return true;
      }
      
      // Expiry weeks must be > 0 (positive integer)
      const expiryWeeks = parseInt(service.expiry_weeks, 10);
      if (isNaN(expiryWeeks) || expiryWeeks <= 0) {
        return true;
      }
      
      // Cancellation window hours must be > 0
      const cancellationHours = parseInt(service.cancellation_window_hours, 10);
      if (isNaN(cancellationHours) || cancellationHours <= 0) {
        return true;
      }
    } else if (allowMultiSessions && (service.sessions_count || service.expiry_weeks || service.schedule_type)) {
      // If service has any multi-session fields but is not explicitly multi_session, validate them if they exist
      if (service.sessions_count && service.sessions_count !== "") {
        const sessionsCount = parseInt(service.sessions_count, 10);
        if (isNaN(sessionsCount) || sessionsCount < 2) {
          return true;
        }
      }

      if (service.expiry_weeks && service.expiry_weeks !== "") {
        const expiryWeeks = parseInt(service.expiry_weeks, 10);
        if (isNaN(expiryWeeks) || expiryWeeks <= 0) {
          return true;
        }
      }

      if (service.cancellation_window_hours && service.cancellation_window_hours !== "") {
        const cancellationHours = parseInt(service.cancellation_window_hours, 10);
        if (isNaN(cancellationHours) || cancellationHours <= 0) {
          return true;
        }
      }
    }

    // For single services, cancellation_window_hours is always required
    if (service.service_type !== "multi_session") {
      if (!service.cancellation_window_hours || service.cancellation_window_hours === "") {
        return true;
      }
      const cancellationHours = parseInt(service.cancellation_window_hours, 10);
      if (isNaN(cancellationHours) || cancellationHours <= 0) {
        return true;
      }
    }

    return false;
  };

  const isEditServiceTotalSaveBtnDisabled = () => {
    const hasServicesWithoutRequiredData = addedSepacialtyWithServices?.some(
      (item) => item.services?.some((service) => service.editMood)
    );
    return hasServicesWithoutRequiredData;
  };

  const renderServices = () => {
    return (
      !isLoading && (
        <>
          {!noAssgiendServicesOnSpecialtyAlert ? (
            <>
              <div>
                {values["choosenServices"]?.map((service, i) => {
                  return (
                    <div key={service.serviceId}>
                      <div className="d-flex  align-items-center justify-content-between text-secondary pointer">
                        <Checkbox
                          color="secondary"
                          label={
                            <div>
                              <span className="text-gray text-break fsize-16">
                                {renderTextEllipsis(
                                  lang === "en"
                                    ? service.name_en
                                    : service.name_ar,
                                  40
                                )}
                              </span>
                            </div>
                          }
                          labelClass="font-reguler text-dark fsize-16"
                          checked={values["choosenServices"][i].isChoosen}
                          name={
                            lang === "en" ? service.name_en : service.name_ar
                          }
                          id={service.serviceId}
                          onChange={(elementIsChecked, e) => {
                            // update service variable
                            setFieldValue(
                              "choosenServices",
                              values["choosenServices"].map((service) => {
                                if (service.serviceId == e.target.id) {
                                  service.isChoosen = elementIsChecked;
                                }
                                return service;
                              })
                            );
                            setMappedServices(
                              mappedServices?.map((service) => {
                                if (service.serviceId == e.target.id) {
                                  service.isChoosen = elementIsChecked;
                                }
                                return service;
                              })
                            );
                          }}
                        />
                        {(service.status === "pending" ||
                          service.status === "rejected") && (
                          <div className="d-flex align-items-center gap-2">
                            <EditBgIcon
                              width={26}
                              height={26}
                              onClick={() => {
                                setSelectedManualAddedService(service);
                                setShowAddEditManualServiceModal(true);
                              }}
                            />
                            <DeleteBgIcon
                              width={26}
                              height={26}
                              onClick={() => {
                                setSelectedManualAddedService(service);
                                setShowDeleteManualAddedServiceModal(true);
                              }}
                            />
                            <Tooltip
                              title={
                                <span className="fsize-12">
                                  {service.status === "rejected"
                                    ? service.rejection_reason
                                    : branches.addBranch.specialtiesAndServices
                                        .addedServiceInfo}
                                </span>
                              }
                              content={
                                <span className="text-bg-primary-mid fsize-14 font-reguler mx-2">
                                  {service.status === "rejected" ? (
                                    <PriorityHighIcon
                                      size={26}
                                      style={{
                                        color: "#DC4D2A",
                                        cursor: "default",
                                      }}
                                    />
                                  ) : (
                                    <InfoOutlined
                                      size={26}
                                      style={{
                                        color: "#D19985",
                                        cursor: "default",
                                      }}
                                    />
                                  )}
                                </span>
                              }
                            />
                          </div>
                        )}
                      </div>
                      {/* render details */}
                      {service.isChoosen && (
                        <div className="ms-4 ps-2 service-details-section">
                          <div className="mb-3">
                            <div className="d-flex align-items-center gap-2">

                              <Input
                                id="feesRangeFrom"
                                label={
                                  branches.addBranch.specialtiesAndServices
                                  .feesRange
                                }
                                name="feesRangeFrom"
                                type="text"
                                placeholder={
                                  branches.addBranch.specialtiesAndServices.from
                                }
                                value={
                                  values["choosenServices"][i]?.details
                                    .feesRange.from
                                }
                                inputWrapperClass="select-bg-white"
                                labelClassName="text-dark font-medium mb-2"
                                onChange={(value) => {
                                  if (ONE_NUMBERS_ONLY.test(value) || !value) {
                                    setFieldValue(values["choosenServices"], [
                                      ...values["choosenServices"],
                                      values["choosenServices"].map(
                                        (mappedService) => {
                                          if (
                                            mappedService.serviceId ===
                                            service.serviceId
                                          ) {
                                            // Clear non-required errors first
                                            if (
                                              mappedService.details.feesRange.errors.includes(
                                                "onlyNumbersAreAllowed"
                                              )
                                            ) {
                                              mappedService.details.feesRange.errors =
                                                mappedService.details.feesRange.errors.filter(
                                                  (error) =>
                                                    error !== "onlyNumbersAreAllowed"
                                                );
                                            }

                                            if (TWO_DICIMAL_ONLY.test(value)) {
                                              mappedService.details.feesRange.from = value;
                                              // Clear required error when valid value is entered
                                              mappedService.details.feesRange.errors =
                                                mappedService.details.feesRange.errors.filter(
                                                  (error) => error !== "feesIsRequired" && error !== "fromIsRequired"
                                                );
                                              if (mappedService.details.feesRange.errors.length === 0) {
                                                mappedService.details.feesRange.hasErrors = false;
                                              }
                                            } else if (!value || value === "") {
                                              // Field is empty - update value and show required error
                                              mappedService.details.feesRange.from = "";
                                              if (!mappedService.details.feesRange.errors.includes("feesIsRequired")) {
                                                mappedService.details.feesRange.hasErrors = true;
                                                mappedService.details.feesRange.errors.push("feesIsRequired");
                                              }
                                            }
                                          }
                                          return mappedService;
                                        }
                                      ),
                                    ]);
                                  } else {
                                    setFieldValue(values["choosenServices"], [
                                      ...values["choosenServices"],
                                      values["choosenServices"].map(
                                        (mappedService) => {
                                          if (
                                            mappedService.serviceId ===
                                            service.serviceId
                                          ) {
                                            if (
                                              !mappedService.details.feesRange.errors.includes(
                                                "onlyNumbersAreAllowed"
                                              )
                                            ) {
                                              mappedService.details.feesRange.hasErrors = true;
                                              mappedService.details.feesRange.errors.push(
                                                "onlyNumbersAreAllowed"
                                              );
                                            }
                                          }
                                          return mappedService;
                                        }
                                      ),
                                    ]);
                                  }
                                }}
                                onBlur={() => {
                                  const currentValue = values["choosenServices"][i]?.details.feesRange.from;
                                  if (!currentValue || currentValue === "") {
                                    setFieldValue(values["choosenServices"], [
                                      ...values["choosenServices"],
                                      values["choosenServices"].map(
                                        (mappedService) => {
                                          if (mappedService.serviceId === service.serviceId) {
                                            if (!mappedService.details.feesRange.errors.includes("feesIsRequired")) {
                                              mappedService.details.feesRange.hasErrors = true;
                                              mappedService.details.feesRange.errors.push("feesIsRequired");
                                            }
                                          }
                                          return mappedService;
                                        }
                                      ),
                                    ]);
                                  }
                                }}
                                required
                              />
                            </div>
                            {values["choosenServices"][i]?.details.feesRange
                              .hasErrors && (
                              <span>
                                {values["choosenServices"][
                                  i
                                ]?.details.feesRange.errors.map((err) => {
                                  return (
                                    <div className="text-red fweight-600">
                                      {lang == "en" ? (
                                        errorss.find((x) => {
                                          return x.errorTitle == err;
                                        })?.errorMessaged
                                      ) : (
                                        <>
                                          {
                                            errorss.find((x) => {
                                              return x.errorTitle == err;
                                            })?.errorMessaged
                                          }
                                        </>
                                      )}
                                    </div>
                                  );
                                })}
                              </span>
                            )}
                          </div>
                          <div className="mb-3">
                            <div className="d-flex align-items-center">
                              <Select
                                wrapperClass="label-inline"
                                name="currency"
                                labelClassName={`text-dark font-medium mb-2`}
                                label={
                                  branches.addBranch.specialtiesAndServices
                                    .currency
                                }
                                options={currencyOptionsList}
                                inputClassName={`input-wrapper select-bg-white ${
                                  lang == "ar" ? "handle-padding" : ""
                                }`}
                                placeholder={
                                  branches.addBranch.specialtiesAndServices
                                    .currency
                                }
                                value={
                                  values["choosenServices"][i]?.details.currency
                                }
                                onChange={(value) => {
                                  setFieldValue(values["choosenServices"], [
                                    ...values["choosenServices"],
                                    values["choosenServices"].map(
                                      (mappedService) => {
                                        if (
                                          mappedService.serviceId ===
                                          service.serviceId
                                        ) {
                                          mappedService.details.currency = value;

                                          // Check if field is empty and show required error
                                          if (!value || value === null) {
                                            if (!mappedService.details.errors.includes("currencyIsRequired")) {
                                              mappedService.details.hasErrors = true;
                                              mappedService.details.errors.push("currencyIsRequired");
                                            }
                                          } else {
                                            // Clear required error when valid value is selected
                                            mappedService.details.errors =
                                              mappedService.details.errors.filter(
                                                (error) =>
                                                  error !== "currencyIsRequired"
                                              );
                                            if (mappedService.details.errors.length === 0) {
                                              mappedService.details.hasErrors = false;
                                            }
                                          }
                                        }
                                        return service;
                                      }
                                    ),
                                  ]);
                                }}
                                required
                              />
                            </div>
                            {values["choosenServices"][i]?.details.hasErrors &&
                              values["choosenServices"][
                                i
                              ]?.details.errors.includes(
                                "currencyIsRequired"
                              ) && (
                                <span>
                                  {values["choosenServices"][
                                    i
                                  ]?.details.errors.map((err) => {
                                    return (
                                      <div className="text-red fweight-600">
                                        {lang == "en" ? (
                                          errorss.find((x) => {
                                            return (
                                              x.errorTitle == err &&
                                              err == "currencyIsRequired"
                                            );
                                          })?.errorMessaged
                                        ) : (
                                          <>
                                            {
                                              errorss.find((x) => {
                                                return (
                                                  x.errorTitle == err &&
                                                  err == "currencyIsRequired"
                                                );
                                              })?.errorMessaged
                                            }
                                          </>
                                        )}
                                      </div>
                                    );
                                  })}
                                </span>
                              )}
                          </div>
                          <div className="mb-3">
                            <div className="d-flex align-items-center">
                              <Input
                                id="duration"
                                label={
                                  branches.addBranch.specialtiesAndServices
                                    .duration
                                }
                                name="duration"
                                type="text"
                                placeholder={
                                  branches.addBranch.specialtiesAndServices
                                    .duration
                                }
                                value={
                                  values["choosenServices"][i]?.details.duration
                                }
                                inputWrapperClass=" select-bg-white"
                                labelClassName="text-dark font-medium mb-2"
                                onChange={(value) => {
                                  if (
                                    (ONE_NUMBERS_ONLY.test(value) ||
                                      value === "") &&
                                    value !== "0"
                                  ) {
                                    setFieldValue(values["choosenServices"], [
                                      ...values["choosenServices"],
                                      values["choosenServices"].map(
                                        (mappedService) => {
                                          if (
                                            mappedService.serviceId ===
                                            service.serviceId
                                          ) {
                                            // Clear non-required errors first
                                            if (
                                              mappedService.details.errors.includes(
                                                "onlyNumbersAreAllowed"
                                              ) ||
                                              mappedService.details.errors.includes(
                                                "durationCanNotBeLessThanOne"
                                              )
                                            ) {
                                              mappedService.details.errors =
                                                mappedService.details.errors.filter(
                                                  (error) =>
                                                    error !==
                                                      "onlyNumbersAreAllowed" &&
                                                    error !==
                                                      "durationCanNotBeLessThanOne"
                                                );
                                            }

                                            mappedService.details.duration = value;

                                            // Check if field is empty and show required error
                                            if (!value || value === "") {
                                              if (!mappedService.details.errors.includes("durationIsRequired")) {
                                                mappedService.details.hasErrors = true;
                                                mappedService.details.errors.push("durationIsRequired");
                                              }
                                            } else {
                                              // Clear required error when valid value is entered
                                              mappedService.details.errors =
                                                mappedService.details.errors.filter(
                                                  (error) => error !== "durationIsRequired"
                                                );
                                              if (mappedService.details.errors.length === 0) {
                                                mappedService.details.hasErrors = false;
                                              }
                                            }
                                          }
                                          return service;
                                        }
                                      ),
                                    ]);
                                  } else {
                                    setFieldValue(values["choosenServices"], [
                                      ...values["choosenServices"],
                                      values["choosenServices"].map(
                                        (mappedService) => {
                                          if (
                                            mappedService.serviceId ===
                                            service.serviceId
                                          ) {
                                            if (
                                              value === "0" &&
                                              !mappedService.details.errors.includes(
                                                "durationCanNotBeLessThanOne"
                                              )
                                            ) {
                                              mappedService.details.hasErrors = true;
                                              mappedService.details.errors = [
                                                "durationCanNotBeLessThanOne",
                                              ];
                                            } else if (
                                              !mappedService.details.errors.includes(
                                                "onlyNumbersAreAllowed"
                                              )
                                            ) {
                                              mappedService.details.hasErrors = true;
                                              mappedService.details.errors = [
                                                "onlyNumbersAreAllowed",
                                              ];
                                            }
                                          }
                                          return service;
                                        }
                                      ),
                                    ]);
                                  }
                                }}
                                required
                              />
                              <p className="text-gray fsize-16  mb-0 mx-2 mb-3">
                                {
                                  branches.addBranch.specialtiesAndServices
                                    .minutes
                                }
                              </p>
                            </div>
                            {values["choosenServices"][i]?.details
                              .hasErrors && (
                              <span>
                                {values["choosenServices"][
                                  i
                                ]?.details.errors.map((err) => {
                                  return (
                                    <div className="text-red fweight-600">
                                      {lang == "en" ? (
                                        errorss.find((x) => {
                                          return (
                                            x.errorTitle == err &&
                                            err !== "currencyIsRequired" &&
                                            err !== "minimumSessionsRequired"
                                          );
                                        })?.errorMessaged
                                      ) : (
                                        <>
                                          {
                                            errorss.find((x) => {
                                              return (
                                                x.errorTitle == err &&
                                                err !== "currencyIsRequired" &&
                                                err !== "minimumSessionsRequired"
                                              );
                                            })?.errorMessaged
                                          }
                                        </>
                                      )}
                                    </div>
                                  );
                                })}
                              </span>
                            )}
                          </div>
                          {/* <Input
                            id="description"
                            label={branches.addBranch.specialtiesAndServices.description}
                            name="description"
                            type="text"
                            placeholder={branches.addBranch.specialtiesAndServices.description}
                            value={values['choosenServices'][i]?.details.description}
                            inputWrapperClass="mb-3 select-bg-white"
                            labelClassName="text-dark font-medium mb-2"
                            onChange={(value) => {
                              setFieldValue(values['choosenServices'], [
                                ...values['choosenServices'],
                                values['choosenServices'].map((mappedService) => {
                                  if (mappedService.serviceId === service.serviceId) {
                                    mappedService.details.description = value;
                                  }
                                  return service;
                                }),
                              ]);
                            }}
                          /> */}
                          <div className="mb-3">
                            <Input
                              id="descriptionEN"
                              label={
                                branches.addBranch.specialtiesAndServices
                                  .descriptionEN
                              }
                              name="descriptionEN"
                              type="text"
                              multiline
                              inputProps={{ maxLength: 125 }}
                              placeholder={
                                branches.addBranch.specialtiesAndServices
                                  .descriptionEN
                              }
                              value={
                                values["choosenServices"][i]?.details
                                  .descriptionEN.value
                              }
                              labelClassName="text-dark font-medium mb-2"
                              inputClass="select-bg-white p-14"
                              onChange={(value) => {
                                if (
                                  ONLY_ENGLISH_SPACE_DOT_COMMA_SEMICOLON.test(
                                    value
                                  ) ||
                                  !value
                                ) {
                                  setFieldValue(values["choosenServices"], [
                                    ...values["choosenServices"],
                                    values["choosenServices"].map(
                                      (mappedService) => {
                                        if (
                                          mappedService.serviceId ===
                                          service.serviceId
                                        ) {
                                          mappedService.details.descriptionEN.hasErrors = false;
                                          mappedService.details.descriptionEN.errors =
                                            "";
                                          mappedService.details.descriptionEN.value =
                                            value;
                                        }
                                        return service;
                                      }
                                    ),
                                  ]);
                                } else {
                                  setFieldValue(values["choosenServices"], [
                                    ...values["choosenServices"],
                                    values["choosenServices"].map(
                                      (mappedService) => {
                                        if (
                                          mappedService.serviceId ===
                                          service.serviceId
                                        ) {
                                          mappedService.details.descriptionEN.hasErrors = true;
                                          mappedService.details.descriptionEN.errors =
                                            "onlyEnglishSpaceDotCommaSemicolon";
                                        }
                                        return service;
                                      }
                                    ),
                                  ]);
                                }
                              }}
                            />
                            {service?.details.descriptionEN.hasErrors && (
                              <div className="text-red fweight-600">
                                {
                                  errorss.find((x) => {
                                    return (
                                      x.errorTitle ==
                                      "onlyEnglishSpaceDotCommaSemicolon"
                                    );
                                  })?.errorMessaged
                                }
                              </div>
                            )}
                          </div>
                          <div className="mb-3">
                            <Input
                              id="descriptionAR"
                              label={
                                branches.addBranch.specialtiesAndServices
                                  .descriptionAR
                              }
                              name="descriptionAR"
                              type="text"
                              multiline
                              inputProps={{ maxLength: 125 }}
                              placeholder={
                                branches.addBranch.specialtiesAndServices
                                  .descriptionAR
                              }
                              value={
                                values["choosenServices"][i]?.details
                                  .descriptionAR.value
                              }
                              inputClass="select-bg-white p-14"
                              labelClassName="text-dark font-medium mb-2"
                              onChange={(value) => {
                                if (
                                  ONLY_ARABIC_SPACE_DOT_COMMA_SEMICOLON.test(
                                    value
                                  ) ||
                                  !value
                                ) {
                                  setFieldValue(values["choosenServices"], [
                                    ...values["choosenServices"],
                                    values["choosenServices"].map(
                                      (mappedService) => {
                                        if (
                                          mappedService.serviceId ===
                                          service.serviceId
                                        ) {
                                          mappedService.details.descriptionAR.hasErrors = false;
                                          mappedService.details.descriptionAR.errors =
                                            "";
                                          mappedService.details.descriptionAR.value =
                                            value;
                                        }
                                        return service;
                                      }
                                    ),
                                  ]);
                                } else {
                                  setFieldValue(values["choosenServices"], [
                                    ...values["choosenServices"],
                                    values["choosenServices"].map(
                                      (mappedService) => {
                                        if (
                                          mappedService.serviceId ===
                                          service.serviceId
                                        ) {
                                          mappedService.details.descriptionAR.hasErrors = true;
                                          mappedService.details.descriptionAR.errors =
                                            "onlyArabicSpaceDotCommaSemicolon";
                                        }
                                        return service;
                                      }
                                    ),
                                  ]);
                                }
                              }}
                            />
                            {service?.details.descriptionAR.hasErrors && (
                              <div className="text-red fweight-600">
                                {
                                  errorss.find((x) => {
                                    return (
                                      x.errorTitle ==
                                      "onlyArabicSpaceDotCommaSemicolon"
                                    );
                                  })?.errorMessaged
                                }
                              </div>
                            )}
                          </div>
                          {allowMultiSessions && (service?.service_type === "multi_session" ||
                            (service?.sessions_count || service?.expiry_weeks || service?.schedule_type)) && (
                            <>
                              <div className="mb-3">
                                <div className="d-flex align-items-center">
                                  <Input
                                    id="sessionsCount"
                                    label={
                                      branches.addBranch
                                        .specialtiesAndServices
                                        .sessionsNumber
                                    }
                                    name="sessionsCount"
                                    type="text"
                                    inputWrapperClass="select-bg-white"
                                    labelClassName="text-dark font-medium mb-2"
                                    required
                                    placeholder={
                                      branches.addBranch
                                        .specialtiesAndServices
                                        .sessionsNumberPlaceholder
                                    }
                                    value={values["choosenServices"][i]?.sessions_count || ""}
                                    onChange={(value) => {
                                      if (NUMBERS_REGEX.test(value) || !value) {
                                        setFieldValue(values["choosenServices"], [
                                          ...values["choosenServices"],
                                          values["choosenServices"].map(
                                            (mappedService) => {
                                              if (
                                                mappedService.serviceId ===
                                                service.serviceId
                                              ) {
                                                mappedService.sessions_count = value;
                                                // validation: required & min 2 (same as AddEditManualServiceModal)
                                                const trimmed = (value || "").trim();
                                                if (!trimmed) {
                                                  mappedService.sessionsCountError = "required";
                                                } else {
                                                  const numValue = parseInt(trimmed, 10);
                                                  if (Number.isNaN(numValue) || numValue < 2) {
                                                    mappedService.sessionsCountError = "minimumTwoSessionsRequired";
                                                  } else {
                                                    mappedService.sessionsCountError = "";
                                                  }
                                                }
                                              }
                                              return mappedService;
                                            }
                                          ),
                                        ]);
                                      }
                                    }}
                                  />
                                </div>
                                {service.sessionsCountError && (
                                  <div className="text-red fweight-600 mt-1">
                                    {service.sessionsCountError === "minimumTwoSessionsRequired"
                                      ? inputsValidations.minimumTwoSessionsRequired
                                      : inputsValidations.required}
                                  </div>
                                )}
                              </div>
                              <div className="mb-3">
                              <div className="d-flex align-items-center">
                                <Input
                                  id="expiryWeeks"
                                  label={
                                    branches.addBranch
                                      .specialtiesAndServices
                                      .sessionsExpiry
                                  }
                                  name="expiryWeeks"
                                  type="text"
                                  required
                                  placeholder={
                                    branches.addBranch
                                      .specialtiesAndServices
                                      .sessionsExpiryPlaceholder
                                  }
                                  value={values["choosenServices"][i]?.expiry_weeks || ""}
                                  inputWrapperClass="select-bg-white"
                                  labelClassName="text-dark font-medium mb-2"
                                  onChange={(value) => {
                                    if (NUMBERS_REGEX.test(value) || !value) {
                                      setFieldValue(values["choosenServices"], [
                                        ...values["choosenServices"],
                                        values["choosenServices"].map(
                                          (mappedService) => {
                                            if (
                                              mappedService.serviceId ===
                                              service.serviceId
                                            ) {
                                              mappedService.expiry_weeks = value;
                                              // validation: positive int required (> 0)
                                              const trimmed = (value || "").trim();
                                              if (!trimmed) {
                                                mappedService.expiryWeeksError = "required";
                                              } else {
                                                const numValue = parseInt(trimmed, 10);
                                                if (Number.isNaN(numValue) || numValue <= 0) {
                                                  mappedService.expiryWeeksError = "required";
                                                } else {
                                                  mappedService.expiryWeeksError = "";
                                                }
                                              }
                                            }
                                            return mappedService;
                                          }
                                        ),
                                      ]);
                                    }
                                  }}
                                />
                                 <p className="text-gray fsize-16 mx-2 mb-2">
                                {
                                  branches.addBranch.specialtiesAndServices
                                    .weeks
                                }
                              </p>
                                </div>
                                {service.expiryWeeksError && (
                                  <div className="text-red fweight-600 mt-1">
                                    {inputsValidations.required}
                                  </div>
                                )}
                              </div>
                              <div className="mb-3 d-flex align-items-baseline gap-2">
                                  <div className="text-dark font-medium">
                                    {
                                      branches.addBranch
                                        .specialtiesAndServices
                                        .scheduleType
                                    }
                                    <span className="err-asterisk"> * </span>
                                  </div>
                                  {values["choosenServices"][i]?.schedule_type && (
                                    <div className="ms-2">
                                      <Tooltip
                                        title={
                                          <span className="fsize-12">
                                            {values["choosenServices"][i]?.schedule_type === "upfront"
                                              ? branches.addBranch
                                                  .specialtiesAndServices
                                                  .scheduleAllUpfrontTooltip
                                              : values["choosenServices"][i]?.schedule_type === "rolling"
                                              ? branches.addBranch
                                                  .specialtiesAndServices
                                                  .rollingWindowTooltip
                                              : ""}
                                          </span>
                                        }
                                        content={
                                          <span className="text-bg-primary-mid fsize-14 font-reguler">
                                            <InfoOutlined
                                              size={20}
                                              style={{
                                                color: "#D19985",
                                                cursor: "default",
                                                transform: "translateY(-1px)",
                                              }}
                                            />
                                          </span>
                                        }
                                      />
                                    </div>
                                  )}
                                <div className="d-flex flex-column"> 
                                <Select
                                  name="scheduleType"
                                  labelClassName="d-none"
                                  options={[
                                    {
                                      id: "upfront",
                                      label:
                                      branches.addBranch
                                        .specialtiesAndServices
                                        .scheduleAllUpfront,
                                      value: "upfront",
                                    },
                                    {
                                      id: "rolling",
                                      label:
                                      branches.addBranch
                                        .specialtiesAndServices
                                        .rollingWindow,
                                      value: "rolling",
                                    },
                                  ]}
                                  inputClassName="input-wrapper select-bg-white w-100"
                                  placeholder={
                                    branches.addBranch
                                      .specialtiesAndServices
                                      .scheduleTypePlaceholder
                                  }
                                  value={
                                    values["choosenServices"][i]?.schedule_type
                                      ? {
                                          id: values["choosenServices"][i]?.schedule_type,
                                          label:
                                            values["choosenServices"][i]?.schedule_type === "upfront"
                                              ? branches.addBranch
                                                  .specialtiesAndServices
                                                  .scheduleAllUpfront
                                              : branches.addBranch
                                                  .specialtiesAndServices
                                                  .rollingWindow,
                                          value: values["choosenServices"][i]?.schedule_type,
                                        }
                                      : null
                                  }
                                  onChange={(value) => {
                                    setFieldValue(values["choosenServices"], [
                                      ...values["choosenServices"],
                                      values["choosenServices"].map(
                                        (mappedService) => {
                                          if (
                                            mappedService.serviceId ===
                                            service.serviceId
                                          ) {
                                            mappedService.schedule_type =
                                              value?.value || null;
                                            // validation: required field
                                            if (!value || !value?.value) {
                                              mappedService.scheduleTypeError = "required";
                                            } else {
                                              mappedService.scheduleTypeError = "";
                                            }
                                          }
                                          return mappedService;
                                        }
                                      ),
                                    ]);
                                  }}
                                  required
                                />
                              </div>
                              {service.scheduleTypeError && (
                                <div className="text-red fweight-600 mt-1">
                                  {inputsValidations.required}
                                </div>
                              )}
                              </div>
                              <div className="mb-3 d-flex align-items-center gap-2">
                                <div className="d-flex align-items-center">
                                  <div className="text-dark font-medium">
                                    {
                                      branches.addBranch
                                        .specialtiesAndServices
                                        .cancellationWindow
                                    }
                                    <span className="err-asterisk"> * </span>
                                  </div>
                                  <div className="ms-2">
                                    <Tooltip
                                      title={
                                        <span className="fsize-12">
                                          {
                                            branches.addBranch
                                              .specialtiesAndServices
                                              .cancellationWindowTooltip
                                          }
                                        </span>
                                      }
                                      content={
                                        <span className="text-bg-primary-mid fsize-14 font-reguler">
                                          <InfoOutlined
                                            size={20}
                                            style={{
                                              color: "#D19985",
                                              cursor: "default",
                                              transform: "translateY(-1px)",
                                            }}
                                          />
                                        </span>
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="d-flex align-items-center">
                                <Input
                                  id="cancellationWindowHours"
                                  name="cancellationWindowHours"
                                  type="text"
                                  required
                                  placeholder={
                                    branches.addBranch
                                      .specialtiesAndServices
                                      .cancellationWindowPlaceholder
                                  }
                                  value={values["choosenServices"][i]?.cancellation_window_hours || ""}
                                  inputWrapperClass="mb-0"
                                  labelClassName="d-none"
                                  onChange={(value) => {
                                    if (NUMBERS_REGEX.test(value) || !value) {
                                      setFieldValue(values["choosenServices"], [
                                        ...values["choosenServices"],
                                        values["choosenServices"].map(
                                          (mappedService) => {
                                            if (
                                              mappedService.serviceId ===
                                              service.serviceId
                                            ) {
                                              mappedService.cancellation_window_hours = value;
                                              // validation: positive int required (> 0)
                                              const trimmed = (value || "").trim();
                                              if (!trimmed) {
                                                mappedService.cancellationWindowHoursError = "required";
                                              } else {
                                                const numValue = parseInt(trimmed, 10);
                                                if (Number.isNaN(numValue) || numValue <= 0) {
                                                  mappedService.cancellationWindowHoursError = "required";
                                                } else {
                                                  mappedService.cancellationWindowHoursError = "";
                                                }
                                              }
                                            }
                                            return mappedService;
                                          }
                                        ),
                                      ]);
                                    }
                                  }}
                                />
                                <p className="text-gray fsize-16 mx-2 mb-2">
                                {
                                  branches.addBranch.specialtiesAndServices
                                    .hours
                                }
                              </p>
                              </div>
                              {service.cancellationWindowHoursError && (
                                <div className="text-red fweight-600 mt-1">
                                  {inputsValidations.required}
                                </div>
                              )}
                              </div>
                            </>
                          )}
                          {service?.service_type !== "multi_session" && (
                            <div className="mb-3 d-flex align-items-center gap-2">
                              <div className="d-flex align-items-center">
                                <div className="text-dark font-medium">
                                  {branches.addBranch.specialtiesAndServices.cancellationWindow}
                                  <span className="err-asterisk"> * </span>
                                </div>
                                <div className="ms-2">
                                  <Tooltip
                                    title={
                                      <span className="fsize-12">
                                        {branches.addBranch.specialtiesAndServices.cancellationWindowServiceTooltip}
                                      </span>
                                    }
                                    content={
                                      <span className="text-bg-primary-mid fsize-14 font-reguler">
                                        <InfoOutlined
                                          size={20}
                                          style={{
                                            color: "#D19985",
                                            cursor: "default",
                                            transform: "translateY(-1px)",
                                          }}
                                        />
                                      </span>
                                    }
                                  />
                                </div>
                              </div>
                              <div className="d-flex align-items-center">
                                <Input
                                  id="cancellationWindowHours"
                                  name="cancellationWindowHours"
                                  type="text"
                                  required
                                  placeholder={branches.addBranch.specialtiesAndServices.cancellationWindowPlaceholder}
                                  value={values["choosenServices"][i]?.cancellation_window_hours || ""}
                                  inputWrapperClass="mb-0"
                                  labelClassName="d-none"
                                  onChange={(value) => {
                                    if (NUMBERS_REGEX.test(value) || !value) {
                                      setFieldValue(values["choosenServices"], [
                                        ...values["choosenServices"],
                                        values["choosenServices"].map((mappedService) => {
                                          if (mappedService.serviceId === service.serviceId) {
                                            mappedService.cancellation_window_hours = value;
                                            const trimmed = (value || "").trim();
                                            if (!trimmed) {
                                              mappedService.cancellationWindowHoursError = "required";
                                            } else {
                                              const numValue = parseInt(trimmed, 10);
                                              if (Number.isNaN(numValue) || numValue <= 0) {
                                                mappedService.cancellationWindowHoursError = "required";
                                              } else {
                                                mappedService.cancellationWindowHoursError = "";
                                              }
                                            }
                                          }
                                          return mappedService;
                                        }),
                                      ]);
                                    }
                                  }}
                                />
                                <p className="text-gray fsize-16 mx-2 mb-2">
                                  {branches.addBranch.specialtiesAndServices.hours}
                                </p>
                              </div>
                              {service.cancellationWindowHoursError && (
                                <div className="text-red fweight-600 mt-1">
                                  {inputsValidations.required}
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      )}
                      {/* line */}
                      {<div className="line-separator"></div>}
                    </div>
                  );
                })}
              </div>
              <div
                className="d-flex align-items-center text-secondary pointer"
                onClick={() => {
                  setShowAddEditManualServiceModal(true);
                  setSelectedManualAddedService(null);
                }}
              >
                <Add />
                {allowMultiSessions
                  ? branches.addBranch.specialtiesAndServices
                      .createNewServiceOrSessions
                  : branches.addBranch.specialtiesAndServices.createNewService}
                <Tooltip
                  title={
                    <span className="fsize-12">
                      {
                        branches.addBranch.specialtiesAndServices
                          .createNewServiceInfo
                      }
                    </span>
                  }
                  content={
                    <span className="text-bg-primary-mid fsize-14 font-reguler mx-2">
                      <InfoOutlined
                        size={26}
                        style={{ color: "#D19985", cursor: "default" }}
                      />
                    </span>
                  }
                />
              </div>
              <div className="mt-4 py-4 d-flex justify-content-end gap-2">
                <Button
                  onClick={() => {
                    // go back to specialties section
                    checkIfThereIsDataBeforeLeave();
                  }}
                  outlined
                  color={"info"}
                  type="button"
                  label={shared.cancel}
                  labelClass="fsize-16 py-1"
                />
                <Button
                  onClick={() => {
                    let valid = true;
                    // check manual validation
                    values["choosenServices"].map((service) => {
                      if (service.isChoosen) {
                        if (!service.details.feesRange.from) {
                          valid = false;
                          service.details.feesRange.hasErrors = true;
                          if (
                            !service.details.feesRange.errors.includes(
                              "fromIsRequired"
                            )
                          ) {
                            service.details.feesRange.errors.push(
                              "fromIsRequired"
                            );
                          }
                        }
                        if (service.details.currency == null) {
                          valid = false;
                          service.details.hasErrors = true;
                          if (
                            !service.details.errors.includes(
                              "currencyIsRequired"
                            )
                          ) {
                            service.details.errors.push("currencyIsRequired");
                          }
                        }
                        if (service.details.currency == null) {
                          valid = false;
                          service.details.hasErrors = true;
                          if (
                            !service.details.errors.includes(
                              "currencyIsRequired"
                            )
                          ) {
                            service.details.errors.push("currencyIsRequired");
                          }
                        }
                        if (!service.details.duration) {
                          valid = false;
                          service.details.hasErrors = true;
                          if (
                            !service.details.errors.includes(
                              "durationIsRequired"
                            )
                          ) {
                            service.details.errors.push("durationIsRequired");
                          }
                        }
                        // Validate cancellation_window_hours for single services
                        if (service.service_type !== "multi_session") {
                          if (!service.cancellation_window_hours) {
                            valid = false;
                          } else {
                            const cancellationHours = parseInt(service.cancellation_window_hours, 10);
                            if (isNaN(cancellationHours) || cancellationHours <= 0) {
                              valid = false;
                            }
                          }
                        }
                        // Validate multi-session fields if service type is multi_session
                        if (service.service_type === "multi_session" || service.sessions_count) {
                          if (!service.sessions_count || parseInt(service.sessions_count) < 2) {
                            valid = false;
                            if (!service.details.errors) {
                              service.details.errors = [];
                            }
                            if (!service.details.errors.includes("minimumSessionsRequired")) {
                              service.details.hasErrors = true;
                              service.details.errors.push("minimumSessionsRequired");
                            }
                          }
                          if (!service.expiry_weeks) {
                            valid = false;
                          } else {
                            const expiryWeeks = parseInt(service.expiry_weeks, 10);
                            if (isNaN(expiryWeeks) || expiryWeeks <= 0) {
                              valid = false;
                            }
                          }
                          if (!service.schedule_type) {
                            valid = false;
                          }
                          if (!service.cancellation_window_hours) {
                            valid = false;
                          } else {
                            const cancellationHours = parseInt(service.cancellation_window_hours, 10);
                            if (isNaN(cancellationHours) || cancellationHours <= 0) {
                              valid = false;
                            }
                          }
                        }
                      }
                      return service;
                    });
                    // add all checked service with details to branch services Call API
                    if (valid) {
                      let arr = [];
                      values["choosenServices"].forEach((service) => {
                        if (service.isChoosen) {
                          let obj = {};
                          obj.id = service.id; // if service is already added to branch
                          obj.service_id = service.serviceId;
                          obj.fees_from = service.details.feesRange.from;
                          // Only include fees_to if not a multi-session service
                          const serviceType = service.service_type || "single_service";
                          obj.fees_to = serviceType === "multi_session" 
                            ? service.details.feesRange.from 
                            : service.details.feesRange.to;
                          obj.duration_mins = service.details.duration;
                          obj.currency_id = service.details.currency?.id;
                          obj.description_en =
                            service.details.descriptionEN.value.trim();
                          obj.description_ar =
                            service.details.descriptionAR.value.trim();
                          obj.title_en = service.name_en;
                          obj.title_ar = service.name_ar;
                          // Include service_type always
                          obj.service_type = serviceType;
                          obj.cancellation_window_hours = service.cancellation_window_hours ? parseInt(service.cancellation_window_hours, 10) : null;
                          // Add multi-session fields if they exist
                          if (serviceType === "multi_session" || service.sessions_count || service.expiry_weeks || service.schedule_type) {
                            obj.sessions_count = service.sessions_count ? parseInt(service.sessions_count, 10) : null;
                            obj.expiry_weeks = service.expiry_weeks ? parseInt(service.expiry_weeks, 10) : null;
                            obj.schedule_type = service.schedule_type || null;
                          }
                          arr.push(obj);
                        } else {
                          let obj = {};
                          obj.id = service.id; // if service is already added to branch
                          obj.service_id = service.serviceId;
                          obj.fees_from = service.details.feesRange.from;
                          // Include service_type even when destroying
                          const serviceType = service.service_type || "single_service";
                          // Only include fees_to if not a multi-session service
                          obj.fees_to = serviceType === "multi_session" 
                            ? service.details.feesRange.from 
                            : service.details.feesRange.to;
                          obj.duration_mins = service.details.duration;
                          obj.currency_id = service.details.currency?.id;
                          obj.description_en =
                            service.details.descriptionEN.value.trim();
                          obj.description_ar =
                            service.details.descriptionAR.value.trim();
                          obj.title_en = service.name_en;
                          obj.title_ar = service.name_ar;
                          obj._destroy = true;
                          obj.service_type = serviceType;
                          obj.cancellation_window_hours = service.cancellation_window_hours ? parseInt(service.cancellation_window_hours, 10) : null;
                          // Include multi-session fields when destroying (for proper cleanup)
                          if (serviceType === "multi_session" || service.sessions_count || service.expiry_weeks || service.schedule_type) {
                            obj.sessions_count = service.sessions_count ? parseInt(service.sessions_count, 10) : null;
                            obj.expiry_weeks = service.expiry_weeks ? parseInt(service.expiry_weeks, 10) : null;
                            obj.schedule_type = service.schedule_type || null;
                          }
                          arr.push(obj);
                        }
                      });

                      dispatch(
                        editBranchRequest({
                          id:
                            branchCreatedId ||
                            parentProps?.location?.state?.branchDataToEdit?.id,
                          data: {
                            branch_services_attributes: arr,
                          },
                        })
                      );
                      setServiceTitle(null);
                    }
                  }}
                  type="submit"
                  label={shared.save}
                  labelClass="fsize-16 text-white py-1"
                  disabled={isEditSpecialtySaveBtnDisabled()}
                />
              </div>
              <Modal
                open={showLeaveWarningModal}
                handleClose={handleCloseShowLeaveWarningModal}
                title={branches.addBranch.labels.confirmCancel}
                contentClass="mb-5 pb-2 text-primary"
                content={
                  <span>{branches.addBranch.labels.confirmCancelMessage}</span>
                }
                confirmBtnTxt={shared.confirm}
                maxWidth="xs"
                cancelBtnTxt={shared.cancel}
                isContentText={false}
                handleConfirm={handleConfirmShowLeaveWarning}
                handleCancel={handleCloseShowLeaveWarningModal}
                modalClass="delete-services-modal"
                actionsClass="container px-4"
                confirmBtnClass="btn-secondary fsize-14 text-white py-2 "
                cancelBtnClass="fsize-14 py-2"
              />
            </>
          ) : (
            <div className="bg-white rounded-4 services-page d-flex justify-content-center align-items-center flex-column m-4 mt-0">
              <EmptyState
                subTitle={shared.noServicesAddedyet}
                // ButtonLabel={shared.back}
                // handleBtnAction={() => {
                //   setRenderSpecialtiesSection(true);
                //   changeSubTitle('AddSpecialties');
                //   setRenderServicesSection(false);
                //   setRenderAddedServiceSection(false);
                // }}
                showActionButton={false}
                otherActionContent={() => (
                  <div className="d-flex justify-content-center align-items-center gap-2">
                    <Button
                      label={shared.back}
                      type="button"
                      labelClass="fsize-16 text-white px-5"
                      onClick={() => {
                        setRenderSpecialtiesSection(true);
                        changeSubTitle("AddSpecialties");
                        setRenderServicesSection(false);
                        setRenderAddedServiceSection(false);
                      }}
                    />
                    <Button
                      label={
                        <span className="d-flex align-items-center gap-2">
                          {allowMultiSessions
                            ? branches.addBranch.specialtiesAndServices
                                .createNewServiceOrSessions
                            : branches.addBranch.specialtiesAndServices
                                .createNewService}
                          <Tooltip
                            title={
                              <span className="fsize-12">
                                {
                                  branches.addBranch.specialtiesAndServices
                                    .createNewServiceInfo
                                }
                              </span>
                            }
                            content={
                              <span className="text-bg-primary-mid fsize-14 font-reguler">
                                <InfoOutlined
                                  size={26}
                                  style={{ color: "white" }}
                                />
                              </span>
                            }
                          />
                        </span>
                      }
                      type="button"
                      labelClass="fsize-16 text-white px-5"
                      onClick={() => {
                        setShowAddEditManualServiceModal(true);
                        setSelectedManualAddedService(null);
                      }}
                    />
                  </div>
                )}
              />
            </div>
          )}
        </>
      )
    );
  };

  const checkIfThereIsDataBeforeLeave = () => {
    if (values["choosenServices"]?.length > 0) {
      let ShowAlert = false;
      values["choosenServices"].forEach((service) => {
        if (service.isChoosen) {
          ShowAlert = true;
        }
      });
      if (ShowAlert) {
        setShowLeaveWarningModal(true);
      } else {
        clearServicesState();
        setRenderSpecialtiesSection(true);
        changeSubTitle("AddSpecialties");
        changeServiceTitle(null);
        setRenderServicesSection(false);
        setRenderAddedServiceSection(false);
      }
    }
  };

  const handleDeleteClick = (id) => {
    setdeleteSpecialtyId(id);
    setOpenDeleteSepecialtyConfirm(true);
  };

  const handleDeleteSpecialty = () => {
    dispatch(
      deleteBranchSpecialtyRequest({
        id: deleteSpecialtyId,
      })
    );
    dispatch(getDeleteBranchSpecialityStatusRequest(null));
    setTimeout(() => {
      dispatch(
        getBranchRequest(
          branchCreatedId || parentProps?.location?.state?.branchDataToEdit?.id
        )
      );
    }, 1000);
    setOpenDeleteSepecialtyConfirm(false);
    // Check if there is only one specialty in the branch
    if (branchServicesList?.length === 1) {
      setRenderEmpatyStateSection(false);
      setRenderSpecialtiesSection(false);
      changeSubTitle(null);
      setRenderServicesSection(false);
      setRenderAddedServiceSection(true);
    } else {
      dispatch(getBranchRequest(branchCreatedId));
      setRenderAddedServiceSection(false);
      setTimeout(() => {
        setRenderAddedServiceSection(true);
      }, 500);
    }
    setdeleteSpecialtyId(null);
  };

  const handleCloseDeleteSpecilatyConfirmModal = () => {
    setOpenDeleteSepecialtyConfirm(false);
  };

  const handleDeleteServiceClick = (service) => {
    setdeleteServiceId(service.id);
    setOpenDeleteServiceConfirm(true);
  };

  const handleDeleteService = () => {
    dispatch(
      deleteBranchServiceRequest({
        id: deleteServiceId,
      })
    );
    dispatch(getDeleteBranchServiceStatusRequest(null));
    resetForm();
    updateServicesContent();
    setdeleteServiceId(null);
    setOpenDeleteServiceConfirm(false);
    setRenderEmpatyStateSection(true);
    setRenderAddedServiceSection(false);
    setTimeout(() => {
      setRenderEmpatyStateSection(false);
      setRenderAddedServiceSection(true);
    }, 200);
  };

  const handleCloseDeleteServiceConfirmModal = () => {
    setOpenDeleteServiceConfirm(false);
  };

  const viewAddedServices = () => {
    return (
      <>
        {addedSepacialtyWithServices?.length > 0 ? (
          <>
            <div>
              {addedSepacialtyWithServices?.map((specialty, index) => {
                return (
                  <div key={specialty.id}>
                    <Accordion
                      wrapperClassName={`services-section ${
                        index !== 0 && "mt-4"
                      }`}
                      label={
                        <div className="d-flex justify-content-between align-items-center w-100">
                          <div className="fsize-16 fweight-600 text-primary text-break">
                            {renderTextEllipsis(
                              lang === "en"
                                ? specialty?.specialty_title_en
                                : specialty?.specialty_title_ar,
                              40
                            )}
                          </div>
                          <div>
                            <div className="d-flex gap-2 align-items-center">
                              <div
                                className="small-icon-bg"
                                onClick={(e) => {
                                  // delete specialty with all services
                                  e.stopPropagation();
                                  handleDeleteClick(specialty.id);
                                }}
                              >
                                <DeleteBgIcon />
                              </div>
                              <div
                                className="small-icon-bg"
                                onClick={() => {
                                  // clearServicesState();
                                  setChoosenSpecialtyId(
                                    specialty.realSpecialtyId
                                  );
                                  setRenderSpecialtiesSection(false);
                                  setTimeout(() => {
                                    setRenderServicesSection(true);
                                  }, 1000);
                                  changeSubTitle("AddSpecialties");
                                  changeServiceTitle(
                                    lang === "en"
                                      ? specialty.title_en
                                      : specialty.title_ar
                                  );
                                  setRenderAddedServiceSection(false);
                                  setServiceTitle(specialty);
                                }}
                              >
                                <EditBgIcon />
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                      labelClassName={"text-primary flex-grow-1"}
                      body={
                        <>
                          {specialty?.services?.map((service, i) => {
                            return (
                              <div key={service.id}>
                                <div
                                  key={service.id}
                                  className={`${i !== 0 && "mt-4"} mb-2 px-4`}
                                >
                                  <div className="d-flex justify-content-between align-items-center mb-2">
                                    <p className="mb-0 text-primary fsize-16 text-break">
                                      {renderTextEllipsis(
                                        lang === "en"
                                          ? service.name_en
                                          : service.name_ar,
                                        40
                                      )}
                                    </p>
                                    <div className="d-flex h-fit-content">
                                      <div>
                                        <Switch
                                          checked={handleToggleButtonValue(
                                            service.service_id
                                          )}
                                          name="published"
                                          onChange={(e) => {
                                            if (e.target.checked) {
                                              handleActivateOrDeactivateService(
                                                service
                                              );
                                            } else {
                                              setDeactivatedService(service);
                                              setShowDeactivateServicePopup(
                                                true
                                              );
                                            }
                                          }}
                                          disabled={
                                            viewBranchDetails.status ===
                                              "deactivated" ||
                                            viewBranchDetails.status ===
                                              "unpublished"
                                              ? true
                                              : false
                                          }
                                        />
                                      </div>

                                      <div
                                        className="small-icon-bg pointer"
                                        onClick={() => {
                                          handleDeleteServiceClick(service);
                                        }}
                                      >
                                        <DeleteBgIcon />
                                      </div>
                                      <div
                                        className="small-icon-bg pointer"
                                        onClick={() => {
                                          setAddedSepacialtyWithServices(
                                            addedSepacialtyWithServices.map(
                                              (specialty) => {
                                                specialty.services = specialty.services?.map(
                                                  (mappedService) => {
                                                    if (
                                                      mappedService.id ===
                                                      service?.id
                                                    ) {
                                                      service.editMood = true;
                                                    }
                                                    return mappedService;
                                                  }
                                                );
                                                return specialty;
                                              }
                                            )
                                          );
                                        }}
                                      >
                                        <EditBgIcon />
                                      </div>
                                    </div>
                                  </div>
                                  {/* details only */}
                                  {service.editMood === false && (
                                    <div>
                                      <div className="d-flex text-gray align-items-center gap-2 text-gray fsize-16">
                                        <CreditCardOutlined className="text-gray" />
                                        <div className="text-gray fsize-16 mb-0">
                                          {
                                            branches.addBranch
                                              .specialtiesAndServices.feesRange
                                          }
                                          :
                                        </div>
                                        <div>
                                          {service.service_type !== "multi_session" && service.details.feesRange.to && (
                                            <span>
                                              {
                                                branches.addBranch
                                                  .specialtiesAndServices.from
                                              }
                                            </span>
                                          )}
                                          <span className="mx-1">
                                            {service.details.feesRange.from ??
                                              " ... "}
                                          </span>
                                          {lang === "en" ? (
                                            currencyOptionsList.find(
                                              (currency) =>
                                                currency.id ===
                                                service?.details?.currency?.id
                                            )?.label
                                          ) : (
                                            <>
                                              {
                                                currencyOptionsList.find(
                                                  (currency) =>
                                                    currency.id ===
                                                    service?.details?.currency
                                                      ?.id
                                                )?.label
                                              }
                                            </>
                                          )}
                                        </div>
                                        {service.service_type !== "multi_session" && service.details.feesRange.to && (
                                          <>
                                            <div>
                                              <span>-</span>
                                            </div>
                                            <div>
                                              {
                                                branches.addBranch
                                                  .specialtiesAndServices.to
                                              }
                                              <span className="mx-1">
                                                {service.details.feesRange.to ??
                                                  " ... "}
                                              </span>
                                              {lang === "en" ? (
                                                currencyOptionsList.find(
                                                  (currency) =>
                                                    currency.id ===
                                                    service?.details?.currency
                                                      ?.id
                                                )?.label
                                              ) : (
                                                <>
                                                  {
                                                    currencyOptionsList.find(
                                                      (currency) =>
                                                        currency.id ===
                                                        service?.details
                                                          ?.currency?.id
                                                    )?.label
                                                  }
                                                </>
                                              )}
                                            </div>
                                          </>
                                        )}
                                      </div>
                                      <div className="d-flex my-1 gap-2 align-items-center">
                                        <AccessTimeOutlined className="text-gray" />
                                        <div className="text-gray fsize-16 mb-0 d-flex gap-2">
                                          <span>
                                            {
                                              branches.addBranch
                                                .specialtiesAndServices.duration
                                            }
                                            :
                                          </span>
                                          <span>
                                            {service.details.duration}
                                          </span>
                                          <span>
                                            {" "}
                                            {
                                              branches.addBranch
                                                .specialtiesAndServices.minutes
                                            }
                                          </span>
                                        </div>
                                      </div>
                                      <div className="d-flex gap-2 align-items-start">
                                        <ReceiptLongOutlined className="text-gray" />
                                        <div className="text-gray fsize-16 mb-0 d-flex gap-2">
                                          <span>
                                            {
                                              branches.addBranch
                                                .specialtiesAndServices
                                                .description
                                            }
                                            :
                                          </span>
                                          <span>
                                            {renderTextEllipsis(
                                              lang === "en"
                                                ? service.details.descriptionEN
                                                    .value || "-"
                                                : service.details.descriptionAR
                                                    .value || "-",
                                              50
                                            )}
                                          </span>
                                        </div>
                                      </div>
                                      {service.service_type === "multi_session" && (
                                        <>
                                          <div className="d-flex gap-2 align-items-center">
                                            <CategoryOutlined className="text-gray" />
                                            <div className="text-gray fsize-16 mb-0 d-flex gap-2">
                                              <span>
                                                {
                                                  branches.addBranch
                                                    .specialtiesAndServices
                                                    .serviceType
                                                }
                                                :
                                              </span>
                                              <span>
                                                {allowMultiSessions
                                                  ? branches.addBranch
                                                      .specialtiesAndServices
                                                      .serviceTypeMulti
                                                  : branches.addBranch
                                                      .specialtiesAndServices
                                                      .serviceTypeSingle}
                                              </span>
                                            </div>
                                          </div>
                                          <div className="d-flex gap-2 align-items-center">
                                            <EventNoteOutlined className="text-gray" />
                                            <div className="text-gray fsize-16 mb-0 d-flex gap-2">
                                              <span>
                                                {
                                                  branches.addBranch
                                                    .specialtiesAndServices
                                                    .sessionsNumber
                                                }
                                                :
                                              </span>
                                              <span>
                                                {service.sessions_count || "-"}
                                              </span>
                                            </div>
                                          </div>
                                          <div className="d-flex gap-2 align-items-center">
                                            <ScheduleOutlined className="text-gray" />
                                            <div className="text-gray fsize-16 mb-0 d-flex gap-2">
                                              <span>
                                                {
                                                  branches.addBranch
                                                    .specialtiesAndServices
                                                    .sessionsExpiry
                                                }
                                                :
                                              </span>
                                              <span>
                                                {service.expiry_weeks || "-"}{" "}
                                                {service.expiry_weeks &&
                                                  branches.addBranch
                                                    .specialtiesAndServices.weeks}
                                              </span>
                                            </div>
                                          </div>
                                          <div className="d-flex gap-2 align-items-center">
                                            <CalendarViewWeekOutlined className="text-gray" />
                                            <div className="text-gray fsize-16 mb-0 d-flex gap-2">
                                              <span>
                                                {
                                                  branches.addBranch
                                                    .specialtiesAndServices
                                                    .scheduleType
                                                }
                                                :
                                              </span>
                                              <span>
                                                {service.schedule_type ===
                                                "upfront"
                                                  ? branches.addBranch
                                                      .specialtiesAndServices
                                                      .scheduleAllUpfront
                                                  : service.schedule_type ===
                                                    "rolling"
                                                  ? branches.addBranch
                                                      .specialtiesAndServices
                                                      .rollingWindow
                                                  : "-"}
                                              </span>
                                            </div>
                                          </div>
                                        </>
                                      )}
                                      <div className="d-flex gap-2 align-items-center">
                                        <CancelOutlined className="text-gray" />
                                        <div className="text-gray fsize-16 mb-0 d-flex gap-2">
                                          <span>
                                            {
                                              branches.addBranch
                                                .specialtiesAndServices
                                                .cancellationWindow
                                            }
                                            :
                                          </span>
                                          <span>
                                            {service.cancellation_window_hours || "-"}{" "}
                                            {service.cancellation_window_hours &&
                                              branches.addBranch
                                                .specialtiesAndServices.hours}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  {/* edit input */}
                                  {service.editMood === true && (
                                    <>
                                      <div className="service-details-section flex-grow-1">
                                        <div className=" mb-2">
                                          <div className="d-flex align-items-center gap-2">

                                            <Input
                                              id="feesRangeFrom"
                                              label={
                                                branches.addBranch.specialtiesAndServices
                                                .feesRange
                                              }
                                              name="feesRangeFrom"
                                              type="text"
                                              required
                                              placeholder={
                                                branches.addBranch
                                                  .specialtiesAndServices.from
                                              }
                                              value={
                                                service.details.feesRange.from
                                              }
                                              inputWrapperClass="select-bg-white"
                                              labelClassName="text-dark font-medium mb-2"
                                              onChange={(value) => {
                                                if (
                                                  ONE_NUMBERS_ONLY.test(
                                                    value
                                                  ) ||
                                                  !value
                                                ) {
                                                  setAddedSepacialtyWithServices(
                                                    addedSepacialtyWithServices.map(
                                                      (specialty) => ({
                                                        ...specialty,
                                                        services: specialty.services?.map(
                                                          (mappedService) => {
                                                            if (
                                                              mappedService.id ===
                                                              service?.id
                                                            ) {
                                                              mappedService = {
                                                                ...mappedService,
                                                                details: {
                                                                  ...mappedService.details,
                                                                  feesRange: {
                                                                    ...mappedService.details.feesRange,
                                                                    errors: !mappedService.details.feesRange.errors ? [] : mappedService.details.feesRange.errors,
                                                                  },
                                                                },
                                                              };

                                                              if (
                                                                mappedService.details.feesRange.errors.includes(
                                                                  "onlyNumbersAreAllowed"
                                                                ) ||
                                                                mappedService.details.feesRange.errors.includes(
                                                                  "feesIsRequired"
                                                                ) ||
                                                                mappedService.details.feesRange.errors.includes(
                                                                  "fromIsRequired"
                                                                ) ||
                                                                mappedService.details.feesRange.errors.includes(
                                                                  "fieldRequired"
                                                                )
                                                              ) {
                                                                mappedService.details.feesRange.errors =
                                                                  mappedService.details.feesRange.errors.filter(
                                                                    (error) =>
                                                                      error !==
                                                                        "onlyNumbersAreAllowed" &&
                                                                      error !==
                                                                        "feesIsRequired" &&
                                                                      error !==
                                                                        "fromIsRequired" &&
                                                                      error !==
                                                                        "fieldRequired"
                                                                  );
                                                                if (mappedService.details.feesRange.errors.length === 0) {
                                                                  mappedService.details.feesRange.hasErrors = false;
                                                                }
                                                              }
                                                              if (
                                                                TWO_DICIMAL_ONLY.test(
                                                                  value
                                                                )
                                                              ) {
                                                                mappedService.details.feesRange.from =
                                                                  value;
                                                              } else if (!value || value === "") {
                                                                // Field is empty - update value and show required error
                                                                mappedService.details.feesRange.from = "";
                                                                if (!mappedService.details.feesRange.errors.includes("feesIsRequired")) {
                                                                  mappedService.details.feesRange.hasErrors = true;
                                                                  mappedService.details.feesRange.errors.push("feesIsRequired");
                                                                }
                                                              }
                                                            }
                                                            return mappedService;
                                                          }
                                                        ),
                                                      })
                                                    )
                                                  );
                                                } else {
                                                  setAddedSepacialtyWithServices(
                                                    addedSepacialtyWithServices.map(
                                                      (specialty) => ({
                                                        ...specialty,
                                                        services: specialty.services?.map(
                                                          (mappedService) => {
                                                            if (
                                                              mappedService.id ===
                                                              service?.id
                                                            ) {
                                                              mappedService = {
                                                                ...mappedService,
                                                                details: {
                                                                  ...mappedService.details,
                                                                  feesRange: {
                                                                    ...mappedService.details.feesRange,
                                                                  },
                                                                },
                                                              };
                                                              if (
                                                                !mappedService.details.feesRange.errors.includes(
                                                                  "onlyNumbersAreAllowed"
                                                                )
                                                              ) {
                                                                mappedService.details.feesRange.hasErrors = true;
                                                                mappedService.details.feesRange.errors.push(
                                                                  "onlyNumbersAreAllowed"
                                                                );
                                                              }
                                                            }
                                                            return mappedService;
                                                          }
                                                        ),
                                                      })
                                                    )
                                                  );
                                                }
                                              }}
                                              onBlur={() => {
                                                const currentValue = service.details.feesRange.from;
                                                if (!currentValue || currentValue === "") {
                                                  setAddedSepacialtyWithServices(
                                                    addedSepacialtyWithServices.map(
                                                      (spec) => {
                                                        spec.services?.map(
                                                          (mappedService) => {
                                                            if (mappedService.id === service?.id) {
                                                              if (!mappedService.details.feesRange.errors) {
                                                                mappedService.details.feesRange.errors = [];
                                                              }
                                                              if (!mappedService.details.feesRange.errors.includes("feesIsRequired")) {
                                                                mappedService.details.feesRange.hasErrors = true;
                                                                mappedService.details.feesRange.errors.push("feesIsRequired");
                                                              }
                                                            }
                                                            return mappedService;
                                                          }
                                                        );
                                                        return spec;
                                                      }
                                                    )
                                                  );
                                                }
                                              }}
                                            />
                                          </div>
                                          {service?.details.feesRange
                                            .hasErrors && (
                                            <span>
                                              {service?.details.feesRange.errors.map(
                                                (err) => {
                                                  return (
                                                    <div className="text-red fweight-600">
                                                      {lang == "en" ? (
                                                        errorss.find((x) => {
                                                          return (
                                                            x.errorTitle == err
                                                          );
                                                        })?.errorMessaged
                                                      ) : (
                                                        <>
                                                          {
                                                            errorss.find(
                                                              (x) => {
                                                                return (
                                                                  x.errorTitle ==
                                                                  err
                                                                );
                                                              }
                                                            )?.errorMessaged
                                                          }
                                                        </>
                                                      )}
                                                    </div>
                                                  );
                                                }
                                              )}
                                            </span>
                                          )}
                                        </div>
                                        <div className="d-flex align-items-center">
                                          <Select
                                            wrapperClass="label-inline"
                                            name="currency"
                                            labelClassName="text-dark font-medium mb-2"
                                            label={
                                              branches.addBranch
                                                .specialtiesAndServices.currency
                                            }
                                            options={currencyOptionsList}
                                            inputClassName={`input-wrapper mb-3 select-bg-white ${
                                              lang === "ar"
                                                ? "handle-padding"
                                                : ""
                                            }`}
                                            required
                                            placeholder={
                                              branches.addBranch
                                                .specialtiesAndServices.currency
                                            }
                                            value={currencyOptionsList?.find(
                                              (x) =>
                                                x.id ===
                                                service?.details?.currency?.id
                                            )}
                                            onChange={(value) => {
                                              setAddedSepacialtyWithServices(
                                                addedSepacialtyWithServices.map(
                                                  (specialty) => {
                                                    specialty.services = specialty.services?.map(
                                                      (mappedService) => {
                                                        if (
                                                          mappedService.id ===
                                                          service?.id
                                                        ) {
                                                          // Initialize errors array if needed
                                                          if (!mappedService.details.errors) {
                                                            mappedService.details.errors = [];
                                                          }
                                                          
                                                          mappedService.details.currency = value;
                                                          
                                                          // Validate required field
                                                          if (!value || value === null) {
                                                            // Field is empty, add required error
                                                            if (!mappedService.details.errors.includes("currencyFieldRequired") && 
                                                                !mappedService.details.errors.includes("currencyIsRequired")) {
                                                              mappedService.details.hasErrors = true;
                                                              mappedService.details.errors.push("currencyFieldRequired");
                                                            }
                                                          } else {
                                                            // Remove required errors if value is set
                                                            mappedService.details.errors = mappedService.details.errors.filter(
                                                              (error) => error !== "currencyFieldRequired" && error !== "currencyIsRequired"
                                                            );
                                                            if (mappedService.details.errors.length === 0) {
                                                              mappedService.details.hasErrors = false;
                                                            }
                                                          }
                                                        }
                                                        return mappedService;
                                                      }
                                                    );
                                                    return specialty;
                                                  }
                                                )
                                              );
                                            }}
                                          />
                                        </div>
                                        {service?.details.hasErrors &&
                                          (service?.details.errors.includes("currencyFieldRequired") ||
                                            service?.details.errors.includes("currencyIsRequired")) && (
                                            <div className="text-red fweight-600 mb-3">
                                              {(() => {
                                                const errorToShow = service?.details.errors.find((err) => 
                                                  err === "currencyFieldRequired" || err === "currencyIsRequired"
                                                );
                                                return lang === "en" ? (
                                                  errorss.find((x) => x.errorTitle === errorToShow)?.errorMessaged
                                                ) : (
                                                  <>
                                                    {
                                                      errorss.find((x) => x.errorTitle === errorToShow)?.errorMessaged
                                                    }
                                                  </>
                                                );
                                              })()}
                                            </div>
                                          )}
                                        <div className="mb-3">
                                          <div className="d-flex align-items-center">
                                            <Input
                                              id="duration"
                                              label={
                                                branches.addBranch
                                                  .specialtiesAndServices
                                                  .duration
                                              }
                                              name="duration"
                                              type="text"
                                              placeholder={
                                                branches.addBranch
                                                  .specialtiesAndServices
                                                  .duration
                                              }
                                              value={service.details.duration}
                                              inputWrapperClass="select-bg-white"
                                              labelClassName="text-dark font-medium mb-2"
                                              required
                                              onChange={(value) => {
                                                if (
                                                  (ONE_NUMBERS_ONLY.test(
                                                    value
                                                  ) ||
                                                    value === "") &&
                                                  value !== "0"
                                                ) {
                                                  setAddedSepacialtyWithServices(
                                                    addedSepacialtyWithServices.map(
                                                      (specialty) => {
                                                        specialty.services?.map(
                                                          (mappedService) => {
                                                            if (
                                                              mappedService.id ===
                                                              service?.id
                                                            ) {
                                                              // Initialize errors array if needed
                                                              if (!mappedService.details.errors) {
                                                                mappedService.details.errors = [];
                                                              }
                                                              
                                                              if (
                                                                mappedService.details.errors.includes(
                                                                  "onlyNumbersAreAllowed"
                                                                ) ||
                                                                mappedService.details.errors.includes(
                                                                  "durationIsRequired"
                                                                ) ||
                                                                mappedService.details.errors.includes(
                                                                  "durationCanNotBeLessThanOne"
                                                                ) ||
                                                                mappedService.details.errors.includes(
                                                                  "durationFieldRequired"
                                                                )
                                                              ) {
                                                                mappedService.details.errors =
                                                                  mappedService.details.errors.filter(
                                                                    (error) =>
                                                                      error !==
                                                                        "onlyNumbersAreAllowed" &&
                                                                      error !==
                                                                        "durationIsRequired" &&
                                                                      error !==
                                                                        "durationCanNotBeLessThanOne" &&
                                                                      error !==
                                                                        "durationFieldRequired"
                                                                  );
                                                                if (mappedService.details.errors.length === 0) {
                                                                  mappedService.details.hasErrors = false;
                                                                }
                                                              }
                                                              mappedService.details.duration = value;
                                                              
                                                              // Validate required field
                                                              if (!value || value === "") {
                                                                // Field is empty, add required error
                                                                if (!mappedService.details.errors.includes("durationFieldRequired") &&
                                                                    !mappedService.details.errors.includes("durationIsRequired")) {
                                                                  mappedService.details.hasErrors = true;
                                                                  mappedService.details.errors.push("durationFieldRequired");
                                                                }
                                                              }
                                                            }
                                                            return mappedService;
                                                          }
                                                        );
                                                        return specialty;
                                                      }
                                                    )
                                                  );
                                                } else {
                                                  setAddedSepacialtyWithServices(
                                                    addedSepacialtyWithServices.map(
                                                      (specialty) => {
                                                        specialty.services?.map(
                                                          (mappedService) => {
                                                            if (
                                                              mappedService.id ===
                                                              service?.id
                                                            ) {
                                                              if (
                                                                value === "0" &&
                                                                !mappedService.details.errors.includes(
                                                                  "durationCanNotBeLessThanOne"
                                                                )
                                                              ) {
                                                                mappedService.details.hasErrors = true;
                                                                mappedService.details.errors =
                                                                  [
                                                                    "durationCanNotBeLessThanOne",
                                                                  ];
                                                              } else if (
                                                                !mappedService.details.errors.includes(
                                                                  "onlyNumbersAreAllowed"
                                                                )
                                                              ) {
                                                                mappedService.details.hasErrors = true;
                                                                // mappedService.details.errors.push('onlyNumbersAreAllowed');
                                                                mappedService.details.errors =
                                                                  [
                                                                    "onlyNumbersAreAllowed",
                                                                  ];
                                                              }
                                                            }
                                                            return mappedService;
                                                          }
                                                        );
                                                        return specialty;
                                                      }
                                                    )
                                                  );
                                                }
                                              }}
                                            />
                                            <p className="text-gray fsize-16 mx-2 mb-0">
                                              {
                                                branches.addBranch
                                                  .specialtiesAndServices
                                                  .minutes
                                              }
                                            </p>
                                          </div>
                                          {service?.details.hasErrors &&
                                            (service?.details.errors.includes("durationFieldRequired") ||
                                              service?.details.errors.includes("durationIsRequired") ||
                                              service?.details.errors.includes("durationCanNotBeLessThanOne") ||
                                              service?.details.errors.includes("onlyNumbersAreAllowed")) && (
                                            <span>
                                              {service?.details.errors.map(
                                                (err) => {
                                                  // Only show duration-related errors
                                                  if (err === "durationFieldRequired" || 
                                                      err === "durationIsRequired" || 
                                                      err === "durationCanNotBeLessThanOne" ||
                                                      err === "onlyNumbersAreAllowed") {
                                                    return (
                                                      <div className="text-red fweight-600" key={err}>
                                                        {lang == "en" ? (
                                                          errorss.find((x) => {
                                                            return x.errorTitle == err;
                                                          })?.errorMessaged
                                                        ) : (
                                                          <>
                                                            {
                                                              errorss.find(
                                                                (x) => {
                                                                  return x.errorTitle == err;
                                                                }
                                                              )?.errorMessaged
                                                            }
                                                          </>
                                                        )}
                                                      </div>
                                                    );
                                                  }
                                                  return null;
                                                }
                                              )}
                                            </span>
                                          )}
                                        </div>
                                        {/* <Input
                                          id="description"
                                          label={branches.addBranch.specialtiesAndServices.description}
                                          name="description"
                                          type="text"
                                          placeholder={branches.addBranch.specialtiesAndServices.description}
                                          value={service.details.description}
                                          inputWrapperClass="mb-3 select-bg-white"
                                          labelClassName="text-dark font-medium mb-2"
                                          onChange={(value) => {
                                            setAddedSepacialtyWithServices(
                                              addedSepacialtyWithServices.map((specialty) => {
                                                specialty.services?.map((mappedService) => {
                                                  if (mappedService.id === service?.id) {
                                                    mappedService.details.description = value;
                                                  }
                                                  return mappedService;
                                                });
                                                return specialty;
                                              })
                                            );
                                          }}
                                        /> */}
                                        <div className="mb-3">
                                          <Input
                                            id="descriptionEN"
                                            label={
                                              branches.addBranch
                                                .specialtiesAndServices
                                                .descriptionEN
                                            }
                                            name="descriptionEN"
                                            type="text"
                                            multiline
                                            inputProps={{ maxLength: 125 }}
                                            placeholder={
                                              branches.addBranch
                                                .specialtiesAndServices
                                                .descriptionEN
                                            }
                                            value={
                                              service.details.descriptionEN
                                                .value
                                            }
                                            inputClass="bg-white p-14"
                                            labelClassName="text-dark font-medium mb-2"
                                            onChange={(value) => {
                                              if (
                                                ONLY_ENGLISH_SPACE_DOT_COMMA_SEMICOLON.test(
                                                  value
                                                ) ||
                                                !value
                                              ) {
                                                setAddedSepacialtyWithServices(
                                                  addedSepacialtyWithServices.map(
                                                    (specialty) => {
                                                      specialty.services = specialty.services?.map(
                                                        (mappedService) => {
                                                          if (
                                                            mappedService.id ===
                                                            service?.id
                                                          ) {
                                                            mappedService.details.descriptionEN.hasErrors = false;
                                                            mappedService.details.descriptionEN.errors =
                                                              "";
                                                            mappedService.details.descriptionEN.value =
                                                              value;
                                                          }
                                                          return mappedService;
                                                        }
                                                      );
                                                      return specialty;
                                                    }
                                                  )
                                                );
                                              } else {
                                                setAddedSepacialtyWithServices(
                                                  addedSepacialtyWithServices.map(
                                                    (specialty) => {
                                                      specialty.services = specialty.services?.map(
                                                        (mappedService) => {
                                                          if (
                                                            mappedService.id ===
                                                            service?.id
                                                          ) {
                                                            mappedService.details.descriptionEN.hasErrors = true;
                                                            mappedService.details.descriptionEN.errors =
                                                              "onlyEnglishSpaceDotCommaSemicolon";
                                                          }
                                                          return mappedService;
                                                        }
                                                      );
                                                      return specialty;
                                                    }
                                                  )
                                                );
                                              }
                                            }}
                                          />
                                          {service?.details.descriptionEN
                                            .hasErrors && (
                                            <div className="text-red fweight-600">
                                              {
                                                errorss.find((x) => {
                                                  return (
                                                    x.errorTitle ==
                                                    "onlyEnglishSpaceDotCommaSemicolon"
                                                  );
                                                })?.errorMessaged
                                              }
                                            </div>
                                          )}
                                        </div>
                                        <div className="mb-3">
                                          <Input
                                            id="descriptionAR"
                                            label={
                                              branches.addBranch
                                                .specialtiesAndServices
                                                .descriptionAR
                                            }
                                            name="descriptionAR"
                                            type="text"
                                            multiline
                                            inputProps={{ maxLength: 125 }}
                                            placeholder={
                                              branches.addBranch
                                                .specialtiesAndServices
                                                .descriptionAR
                                            }
                                            value={
                                              service.details.descriptionAR
                                                .value
                                            }
                                            labelClassName="text-dark font-medium mb-2"
                                            inputClass="bg-white p-14"
                                            onChange={(value) => {
                                              if (
                                                ONLY_ARABIC_SPACE_DOT_COMMA_SEMICOLON.test(
                                                  value
                                                ) ||
                                                !value
                                              ) {
                                                setAddedSepacialtyWithServices(
                                                  addedSepacialtyWithServices.map(
                                                    (specialty) => {
                                                      specialty.services = specialty.services?.map(
                                                        (mappedService) => {
                                                          if (
                                                            mappedService.id ===
                                                            service.id
                                                          ) {
                                                            mappedService.details.descriptionAR.hasErrors = false;
                                                            mappedService.details.descriptionAR.errors =
                                                              "";
                                                            mappedService.details.descriptionAR.value =
                                                              value;
                                                          }
                                                          return mappedService;
                                                        }
                                                      );
                                                      return specialty;
                                                    }
                                                  )
                                                );
                                              } else {
                                                setAddedSepacialtyWithServices(
                                                  addedSepacialtyWithServices.map(
                                                    (specialty) => {
                                                      specialty.services = specialty.services?.map(
                                                        (mappedService) => {
                                                          if (
                                                            mappedService.id ===
                                                            service.id
                                                          ) {
                                                            mappedService.details.descriptionAR.hasErrors = true;
                                                            mappedService.details.descriptionAR.errors =
                                                              "onlyArabicSpaceDotCommaSemicolon";
                                                          }
                                                          return mappedService;
                                                        }
                                                      );
                                                      return specialty;
                                                    }
                                                  )
                                                );
                                              }
                                            }}
                                          />
                                          {service?.details.descriptionAR
                                            .hasErrors && (
                                            <div className="text-red fweight-600">
                                              {
                                                errorss.find((x) => {
                                                  return (
                                                    x.errorTitle ==
                                                    "onlyArabicSpaceDotCommaSemicolon"
                                                  );
                                                })?.errorMessaged
                                              }
                                            </div>
                                          )}
                                        </div>
                                        {allowMultiSessions && service?.service_type === "multi_session" && (
                                          <>
                                            <div className="mb-3">
                                              <div className="d-flex align-items-center">
                                                <Input
                                                  id="sessionsCount"
                                                  label={
                                                    branches.addBranch
                                                      .specialtiesAndServices
                                                      .sessionsNumber
                                                  }
                                                  name="sessionsCount"
                                                  type="text"
                                                  required
                                                  placeholder={
                                                    branches.addBranch
                                                      .specialtiesAndServices
                                                      .sessionsNumberPlaceholder
                                                  }
                                                  value={service.sessions_count || ""}
                                                  inputWrapperClass="select-bg-white"
                                                  labelClassName="text-dark font-medium mb-2"
                                                  onChange={(value) => {
                                                    if (
                                                      NUMBERS_REGEX.test(value) ||
                                                      !value
                                                    ) {
                                                      setAddedSepacialtyWithServices(
                                                        addedSepacialtyWithServices.map(
                                                          (specialty) => {
                                                            specialty.services = specialty.services?.map(
                                                              (mappedService) => {
                                                                if (
                                                                  mappedService.id ===
                                                                  service?.id
                                                                ) {
                                                                  mappedService.sessions_count =
                                                                    value;
                                                                  // validation: required & min 2 (same as AddEditManualServiceModal)
                                                                  const trimmed = (value || "").trim();
                                                                  if (!trimmed) {
                                                                    mappedService.sessionsCountError = "required";
                                                                  } else {
                                                                    const numValue = parseInt(trimmed, 10);
                                                                    if (Number.isNaN(numValue) || numValue < 2) {
                                                                      mappedService.sessionsCountError = "minimumTwoSessionsRequired";
                                                                    } else {
                                                                      mappedService.sessionsCountError = "";
                                                                    }
                                                                  }
                                                                }
                                                                return mappedService;
                                                              }
                                                            );
                                                            return specialty;
                                                          }
                                                        )
                                                      );
                                                    }
                                                  }}
                                                />
                                              </div>
                                              {service.sessionsCountError && (
                                                <div className="text-red fweight-600 mt-1">
                                                  {service.sessionsCountError === "minimumTwoSessionsRequired"
                                                    ? inputsValidations.minimumTwoSessionsRequired
                                                    : inputsValidations.required}
                                                </div>
                                              )}
                                            </div>
                                            <div className="mb-3">
                                              <div className="d-flex align-items-center">
                                                <Input
                                                  id="expiryWeeks"
                                                  label={
                                                    branches.addBranch
                                                      .specialtiesAndServices
                                                      .sessionsExpiry
                                                  }
                                                  name="expiryWeeks"
                                                  type="text"
                                                  required
                                                  placeholder={
                                                    branches.addBranch
                                                      .specialtiesAndServices
                                                      .sessionsExpiryPlaceholder
                                                  }
                                                  value={service.expiry_weeks || ""}
                                                  inputWrapperClass="select-bg-white"
                                                  labelClassName="text-dark font-medium mb-2"
                                                  onChange={(value) => {
                                                    if (
                                                      NUMBERS_REGEX.test(value) ||
                                                      !value
                                                    ) {
                                                      setAddedSepacialtyWithServices(
                                                        addedSepacialtyWithServices.map(
                                                          (specialty) => {
                                                            specialty.services = specialty.services?.map(
                                                              (mappedService) => {
                                                                if (
                                                                  mappedService.id ===
                                                                  service?.id
                                                                ) {
                                                                  mappedService.expiry_weeks = value;
                                                                  // validation: positive int required (> 0)
                                                                  const trimmed = (value || "").trim();
                                                                  if (!trimmed) {
                                                                    mappedService.expiryWeeksError = "required";
                                                                  } else {
                                                                    const numValue = parseInt(trimmed, 10);
                                                                    if (Number.isNaN(numValue) || numValue <= 0) {
                                                                      mappedService.expiryWeeksError = "required";
                                                                    } else {
                                                                      mappedService.expiryWeeksError = "";
                                                                    }
                                                                  }
                                                                }
                                                                return mappedService;
                                                              }
                                                            );
                                                            return specialty;
                                                          }
                                                        )
                                                      );
                                                    }
                                                  }}
                                                />
                                                <p className="text-gray fsize-16 mx-2 mb-2">
                                                  {
                                                    branches.addBranch.specialtiesAndServices
                                                      .weeks
                                                  }
                                                </p>
                                              </div>
                                              {service.expiryWeeksError && (
                                                <div className="text-red fweight-600 mt-1">
                                                  {inputsValidations.required}
                                                </div>
                                              )}
                                            </div>
                                            <div className="mb-3 d-flex align-items-baseline gap-2">
                                              <div className="text-dark font-medium">
                                                {
                                                  branches.addBranch
                                                    .specialtiesAndServices
                                                    .scheduleType
                                                }
                                                <span className="err-asterisk"> * </span>
                                              </div>
                                              {service.schedule_type && (
                                                <div className="ms-2">
                                                  <Tooltip
                                                    title={
                                                      <span className="fsize-12">
                                                        {service.schedule_type === "upfront"
                                                          ? branches.addBranch
                                                              .specialtiesAndServices
                                                              .scheduleAllUpfrontTooltip
                                                          : service.schedule_type === "rolling"
                                                          ? branches.addBranch
                                                              .specialtiesAndServices
                                                              .rollingWindowTooltip
                                                          : ""}
                                                      </span>
                                                    }
                                                    content={
                                                      <span className="text-bg-primary-mid fsize-14 font-reguler">
                                                        <InfoOutlined
                                                          size={20}
                                                          style={{
                                                            color: "#D19985",
                                                            cursor: "default",
                                                            transform: "translateY(-1px)",
                                                          }}
                                                        />
                                                      </span>
                                                    }
                                                  />
                                                </div>
                                              )}
                                              <div className="d-flex flex-column">
                                                <Select
                                                  name="scheduleType"
                                                  labelClassName="d-none"
                                                  options={[
                                                    {
                                                      id: "upfront",
                                                      label:
                                                        branches.addBranch
                                                          .specialtiesAndServices
                                                          .scheduleAllUpfront,
                                                      value: "upfront",
                                                    },
                                                    {
                                                      id: "rolling",
                                                      label:
                                                        branches.addBranch
                                                          .specialtiesAndServices
                                                          .rollingWindow,
                                                      value: "rolling",
                                                    },
                                                  ]}
                                                  inputClassName="input-wrapper select-bg-white w-100"
                                                  placeholder={
                                                    branches.addBranch
                                                      .specialtiesAndServices
                                                      .scheduleTypePlaceholder
                                                  }
                                                  value={
                                                    service.schedule_type
                                                      ? {
                                                          id: service.schedule_type,
                                                          label:
                                                            service.schedule_type === "upfront"
                                                              ? branches.addBranch
                                                                  .specialtiesAndServices
                                                                  .scheduleAllUpfront
                                                              : branches.addBranch
                                                                  .specialtiesAndServices
                                                                  .rollingWindow,
                                                          value: service.schedule_type,
                                                        }
                                                      : null
                                                  }
                                                  onChange={(value) => {
                                                    setAddedSepacialtyWithServices(
                                                      addedSepacialtyWithServices.map(
                                                        (specialty) => {
                                                          specialty.services?.map(
                                                            (mappedService) => {
                                                              if (
                                                                mappedService.id ===
                                                                service?.id
                                                              ) {
                                                                mappedService.schedule_type = value?.value || null;
                                                                // validation: required field
                                                                if (!value || !value?.value) {
                                                                  mappedService.scheduleTypeError = "required";
                                                                } else {
                                                                  mappedService.scheduleTypeError = "";
                                                                }
                                                              }
                                                              return mappedService;
                                                            }
                                                          );
                                                          return specialty;
                                                        }
                                                      )
                                                    );
                                                  }}
                                                  required
                                                />
                                              </div>
                                              {service.scheduleTypeError && (
                                                <div className="text-red fweight-600 mt-1">
                                                  {inputsValidations.required}
                                                </div>
                                              )}
                                            </div>
                                            <div className="mb-3 d-flex align-items-center gap-2">
                                              <div className="d-flex align-items-center">
                                                <div className="text-dark font-medium">
                                                  {
                                                    branches.addBranch
                                                      .specialtiesAndServices
                                                      .cancellationWindow
                                                  }
                                                  <span className="err-asterisk"> * </span>
                                                </div>
                                                <div className="ms-2">
                                                  <Tooltip
                                                    title={
                                                      <span className="fsize-12">
                                                        {
                                                          branches.addBranch
                                                            .specialtiesAndServices
                                                            .cancellationWindowTooltip
                                                        }
                                                      </span>
                                                    }
                                                    content={
                                                      <span className="text-bg-primary-mid fsize-14 font-reguler">
                                                        <InfoOutlined
                                                          size={20}
                                                          style={{
                                                            color: "#D19985",
                                                            cursor: "default",
                                                            transform: "translateY(-1px)",
                                                          }}
                                                        />
                                                      </span>
                                                    }
                                                  />
                                                </div>
                                              </div>
                                              <div className="d-flex align-items-center">
                                                <Input
                                                  id="cancellationWindowHours"
                                                  name="cancellationWindowHours"
                                                  type="text"
                                                  required
                                                  placeholder={
                                                    branches.addBranch
                                                      .specialtiesAndServices
                                                      .cancellationWindowPlaceholder
                                                  }
                                                  value={
                                                    service.cancellation_window_hours || ""
                                                  }
                                                  inputWrapperClass="mb-0"
                                                  labelClassName="d-none"
                                                  onChange={(value) => {
                                                    if (
                                                      NUMBERS_REGEX.test(value) ||
                                                      !value
                                                    ) {
                                                      setAddedSepacialtyWithServices(
                                                        addedSepacialtyWithServices.map(
                                                          (specialty) => {
                                                            specialty.services = specialty.services?.map(
                                                              (mappedService) => {
                                                                if (
                                                                  mappedService.id ===
                                                                  service?.id
                                                                ) {
                                                                  mappedService.cancellation_window_hours = value;
                                                                  const trimmed = (value || "").trim();
                                                                  if (!trimmed) {
                                                                    mappedService.cancellationWindowHoursError = "required";
                                                                  } else {
                                                                    const numValue = parseInt(trimmed, 10);
                                                                    if (Number.isNaN(numValue) || numValue <= 0) {
                                                                      mappedService.cancellationWindowHoursError = "required";
                                                                    } else {
                                                                      mappedService.cancellationWindowHoursError = "";
                                                                    }
                                                                  }
                                                                }
                                                                return mappedService;
                                                              }
                                                            );
                                                            return specialty;
                                                          }
                                                        )
                                                      );
                                                    }
                                                  }}
                                                />
                                                <p className="text-gray fsize-16 mx-2 mb-2">
                                                  {
                                                    branches.addBranch.specialtiesAndServices
                                                      .hours
                                                  }
                                                </p>
                                              </div>
                                              {service.cancellationWindowHoursError && (
                                                <div className="text-red fweight-600 mt-1">
                                                  {inputsValidations.required}
                                                </div>
                                              )}
                                            </div>
                                          </>
                                        )}
                                        {service?.service_type !== "multi_session" && (
                                          <div className="mb-3 d-flex align-items-center gap-2">
                                            <div className="d-flex align-items-center">
                                              <div className="text-dark font-medium">
                                                {branches.addBranch.specialtiesAndServices.cancellationWindow}
                                                <span className="err-asterisk"> * </span>
                                              </div>
                                              <div className="ms-2">
                                                <Tooltip
                                                  title={
                                                    <span className="fsize-12">
                                                      {branches.addBranch.specialtiesAndServices.cancellationWindowServiceTooltip}
                                                    </span>
                                                  }
                                                  content={
                                                    <span className="text-bg-primary-mid fsize-14 font-reguler">
                                                      <InfoOutlined
                                                        size={20}
                                                        style={{
                                                          color: "#D19985",
                                                          cursor: "default",
                                                          transform: "translateY(-1px)",
                                                        }}
                                                      />
                                                    </span>
                                                  }
                                                />
                                              </div>
                                            </div>
                                            <div className="d-flex align-items-center">
                                              <Input
                                                id="cancellationWindowHours"
                                                name="cancellationWindowHours"
                                                type="text"
                                                required
                                                placeholder={branches.addBranch.specialtiesAndServices.cancellationWindowPlaceholder}
                                                value={service.cancellation_window_hours || ""}
                                                inputWrapperClass="mb-0"
                                                labelClassName="d-none"
                                                onChange={(value) => {
                                                  if (NUMBERS_REGEX.test(value) || !value) {
                                                    setAddedSepacialtyWithServices(
                                                      addedSepacialtyWithServices.map((specialty) => {
                                                        specialty.services?.map((mappedService) => {
                                                          if (mappedService.id === service?.id) {
                                                            mappedService.cancellation_window_hours = value;
                                                            const trimmed = (value || "").trim();
                                                            if (!trimmed) {
                                                              mappedService.cancellationWindowHoursError = "required";
                                                            } else {
                                                              const numValue = parseInt(trimmed, 10);
                                                              if (Number.isNaN(numValue) || numValue <= 0) {
                                                                mappedService.cancellationWindowHoursError = "required";
                                                              } else {
                                                                mappedService.cancellationWindowHoursError = "";
                                                              }
                                                            }
                                                          }
                                                          return mappedService;
                                                        });
                                                        return specialty;
                                                      })
                                                    );
                                                  }
                                                }}
                                              />
                                              <p className="text-gray fsize-16 mx-2 mb-2">
                                                {branches.addBranch.specialtiesAndServices.hours}
                                              </p>
                                            </div>
                                            {service.cancellationWindowHoursError && (
                                              <div className="text-red fweight-600 mt-1">
                                                {inputsValidations.required}
                                              </div>
                                            )}
                                          </div>
                                        )}
                                      </div>
                                    </>
                                  )}
                                </div>
                                {service.editMood === true && (
                                  <div className="d-flex ms-auto gap-2 justify-content-end px-4 mb-4">
                                    {/* <Button /> */}
                                    <Button
                                      onClick={() => {
                                        setAddedSepacialtyWithServices(
                                          addedSepacialtyWithServices.map(
                                            (specialty) => {
                                              specialty.services?.map(
                                                (mappedService) => {
                                                  if (
                                                    mappedService.id ===
                                                    service?.id
                                                  ) {
                                                    service.editMood = false;
                                                  }
                                                  return mappedService;
                                                }
                                              );
                                              return specialty;
                                            }
                                          )
                                        );
                                      }}
                                      outlined
                                      color={"info"}
                                      type="button"
                                      label={shared.cancel}
                                      labelClass="fsize-16 text-gray py-1"
                                    />
                                    <Button
                                      onClick={() => {
                                        let editedData = {};
                                        let updatedSpecialty =
                                          addedSepacialtyWithServices.find(
                                            (item) => item.id === specialty.id
                                          );
                                        let updatedService =
                                          updatedSpecialty.services.find(
                                            (item) => item.id === service.id
                                          );
                                        const serviceType = updatedService.service_type || "single_service";
                                        editedData = {
                                          service_id: updatedService.service_id,
                                          id: updatedService.id,
                                          currency_id:
                                            updatedService.currency_id ||
                                            updatedService.details?.currency?.id ||
                                            currencyOptionsList?.find(
                                              (currency) => currency.id === 1
                                            )?.id ||
                                            1,
                                          fees_from:
                                            updatedService.details.feesRange
                                              .from,
                                          // For multi_session, set fees_to to same as fees_from
                                          fees_to:
                                            serviceType === "multi_session"
                                              ? updatedService.details.feesRange.from
                                              : updatedService.details.feesRange.to,
                                          duration_mins:
                                            updatedService.details.duration,
                                          description_en:
                                            updatedService.details.descriptionEN.value.trim(),
                                          description_ar:
                                            updatedService.details.descriptionAR.value.trim(),
                                          service_type: serviceType,
                                          cancellation_window_hours: updatedService.cancellation_window_hours ? parseInt(updatedService.cancellation_window_hours, 10) : null,
                                          // Add multi-session fields if they exist
                                          ...(serviceType === "multi_session" || updatedService.sessions_count || updatedService.expiry_weeks || updatedService.schedule_type
                                            ? {
                                                sessions_count: updatedService.sessions_count ? parseInt(updatedService.sessions_count, 10) : null,
                                                expiry_weeks: updatedService.expiry_weeks ? parseInt(updatedService.expiry_weeks, 10) : null,
                                                schedule_type: updatedService.schedule_type || null,
                                              }
                                            : {}),
                                        };
                                        dispatch(
                                          editBranchServicesRequest({
                                            id: editedData.id,
                                            data: editedData,
                                          })
                                        );
                                        editedData = {};
                                        setAddedSepacialtyWithServices(
                                          addedSepacialtyWithServices.map(
                                            (specialty) => {
                                              specialty.services?.map(
                                                (mappedService) => {
                                                  if (
                                                    mappedService.id ===
                                                    service?.id
                                                  ) {
                                                    service.editMood = false;
                                                  }
                                                  return mappedService;
                                                }
                                              );
                                              return specialty;
                                            }
                                          )
                                        );

                                        // let valid = true;
                                        // // check manual validation
                                        // setAddedSepacialtyWithServices(
                                        //   addedSepacialtyWithServices.map((specialty) => {
                                        //     specialty.services?.map((service) => {
                                        //       if (service.editMood) {
                                        //         if (!service.details.feesRange.from) {
                                        //           valid = false;
                                        //           service.details.feesRange.hasErrors = true;
                                        //           if (!service.details.feesRange.errors.includes('fromIsRequired')) {
                                        //             service.details.feesRange.errors.push('fromIsRequired');
                                        //           }
                                        //         }
                                        //         if (!service.details.duration) {
                                        //           valid = false;
                                        //           service.details.hasErrors = true;
                                        //           if (!service.details.errors.includes('durationIsRequired')) {
                                        //             service.details.errors.push('durationIsRequired');
                                        //           }
                                        //         }
                                        //       }
                                        //       return service;
                                        //     });
                                        //     return specialty;
                                        //   })
                                        // );
                                        // // add all checked service with details to branch services Call API
                                        // if (valid) {
                                        //   let editedData = {};
                                        //   addedSepacialtyWithServices?.forEach((specialty) => {
                                        //     specialty.services?.forEach((service) => {
                                        //       if (service.editMood) {
                                        //         editedData = {
                                        //           service_id: service.service_id,
                                        //           id: service.id,
                                        //           currency_id: currencyOptionsList?.find(
                                        //             (currency) =>
                                        //               currency.id === service.currency_id || currency.id === 1
                                        //           ).id,
                                        //           fees_from: service.details.feesRange.from,
                                        //           fees_to: service.details.feesRange.to,
                                        //           duration_mins: service.details.duration,
                                        //           description_en: service.details.description,
                                        //           description_ar: service.details.description,
                                        //         };
                                        //       }
                                        //     });
                                        //   });
                                        //   dispatch(
                                        //     editBranchServicesRequest({
                                        //       id: editedData.id,
                                        //       data: editedData,
                                        //     })
                                        //   );
                                        //   editedData = {};
                                        //   setAddedSepacialtyWithServices(
                                        //     addedSepacialtyWithServices.map((specialty) => {
                                        //       specialty.services?.map((mappedService) => {
                                        //         if (mappedService.id === service?.id) {
                                        //           service.editMood = false;
                                        //         }
                                        //         return mappedService;
                                        //       });
                                        //       return specialty;
                                        //     })
                                        //   );
                                        //   setRenderEmpatyStateSection(true);
                                        //   setRenderAddedServiceSection(false);
                                        //   setRenderServicesSection(false);
                                        //   setTimeout(() => {
                                        //     setRenderEmpatyStateSection(false);
                                        //     setRenderAddedServiceSection(true);
                                        //   }, 500);
                                        // }
                                      }}
                                      type="button"
                                      // outlined
                                      // color={'info'}
                                      label={shared.save}
                                      labelClass="fsize-16 text-white py-1"
                                      disabled={isEditServiceSaveBtnDisabled(
                                        specialty.id,
                                        service.id
                                      )}
                                    />
                                  </div>
                                )}
                                {/* line */}
                                {i !== specialty?.services?.length - 1 && (
                                  <div className="line-separator-96 mx-auto"></div>
                                )}
                              </div>
                            );
                          })}
                        </>
                      }
                      arrowRotate={specialty?.isExpanded}
                      setArrowRotateValue={(value) => {
                        ArrowChange(value, specialty);
                      }}
                    />
                  </div>
                );
              })}
            </div>
            <div className="mt-4 py-4 d-flex justify-content-end gap-2">
              {/* <Button
                onClick={() => {
                  // go back to specialties section
                  updateServicesContent();
                  setRenderSpecialtiesSection(false);
                  setRenderServicesSection(true);
                  changeSubTitle('AddSpecialties');
                  changeServiceTitle(null);
                  setRenderAddedServiceSection(false);
                }}
                outlined
                type="button"
                color={'info'}
                label={shared.previous}
                labelClass="fsize-16 py-1"
              /> */}
              <Button
                onClick={() => {
                  isEditServiceTotalSaveBtnDisabled()
                    ? setOpenDoneModal(true)
                    : saveAndProcced();
                }}
                type="button"
                // label={parentProps?.location?.state?.cameFrom ? shared.save : shared.saveAndProcced}
                label={shared.done}
                labelClass="fsize-16 text-white py-1"
                // disabled={isEditServiceTotalSaveBtnDisabled()}
              />
            </div>
            <Modal
              open={openDeleteSpecilatyConfirm}
              handleClose={handleCloseDeleteSpecilatyConfirmModal}
              title={branches.addBranch.specialtiesAndServices.deleteSpecialty}
              contentClass="mb-5 pb-2 text-primary"
              content={
                <span>
                  {branches.addBranch.specialtiesAndServices.deleteSpecialtyMsg}
                  <div className="my-3">
                    <span className="text-secondary">
                      {branches.addBranch.specialtiesAndServices.note}:{" "}
                    </span>
                    {
                      branches.addBranch.specialtiesAndServices
                        .deletSpecialityNote
                    }
                  </div>
                </span>
              }
              confirmBtnTxt={shared.delete}
              maxWidth="xs"
              cancelBtnTxt={shared.cancel}
              isContentText={false}
              handleConfirm={handleDeleteSpecialty}
              handleCancel={handleCloseDeleteSpecilatyConfirmModal}
              modalClass="delete-speciialty-modal"
              actionsClass="container px-4"
              confirmBtnClass="btn-secondary fsize-14 text-white py-2 "
              cancelBtnClass="fsize-14 py-2"
            />
            <Modal
              open={openDeleteServiceConfirm}
              handleClose={handleCloseDeleteServiceConfirmModal}
              title={branches.addBranch.specialtiesAndServices.deleteService}
              contentClass="mb-3 pb-2 text-primary"
              content={
                <span>
                  {branches.addBranch.specialtiesAndServices.deleteServiceMsg}
                  <div className="my-3">
                    <span className="text-secondary">
                      {branches.addBranch.specialtiesAndServices.note}:{" "}
                    </span>
                    {
                      branches.addBranch.specialtiesAndServices
                        .deleteServiceNote
                    }
                  </div>
                </span>
              }
              confirmBtnTxt={shared.delete}
              maxWidth="xs"
              cancelBtnTxt={shared.cancel}
              isContentText={false}
              handleConfirm={handleDeleteService}
              handleCancel={handleCloseDeleteServiceConfirmModal}
              modalClass="delete-service-modal"
              actionsClass="container px-4"
              confirmBtnClass="btn-secondary fsize-14 text-white py-2 "
              cancelBtnClass="fsize-14 py-2"
            />
            <Modal
              open={showDeactivateServicePopup}
              handleClose={handleCloseDeactivatePopup}
              title={
                <span>
                  {branches.addBranch.specialtiesAndServices.deactivateService}
                </span>
              }
              contentClass="mb-3 pb-2 text-primary"
              content={
                <span>
                  {
                    branches.addBranch.specialtiesAndServices
                      .deactivateServiceMsg
                  }
                  <div className="my-3">
                    <span className="text-secondary">
                      {branches.addBranch.specialtiesAndServices.note}:{" "}
                    </span>
                    {
                      branches.addBranch.specialtiesAndServices
                        .deactivateServiceNote
                    }
                  </div>
                </span>
              }
              confirmBtnTxt={shared.procced}
              maxWidth="xs"
              cancelBtnTxt={shared.cancel}
              isContentText={false}
              handleConfirm={handleConfirmDecativateService}
              handleCancel={handleCloseDeactivatePopup}
              modalClass="delete-service-modal"
              actionsClass="container px-4"
              confirmBtnClass="btn-secondary fsize-14 text-white py-2 "
              cancelBtnClass="fsize-14 py-2"
            />
            <Modal
              open={openDoneModal}
              handleClose={() => setOpenDoneModal(false)}
              title={
                branches.addBranch.specialtiesAndServices
                  .confirmAllServicesSavedTitle
              }
              contentClass="mb-5 pb-2 text-primary"
              content={
                <span>
                  {
                    branches.addBranch.specialtiesAndServices
                      .confirmAllServicesSavedContent
                  }
                </span>
              }
              isContentText={false}
              confirmBtnTxt={shared.done}
              maxWidth="xs"
              cancelBtnTxt={shared.cancel}
              handleConfirm={saveAndProcced}
              handleCancel={() => setOpenDoneModal(false)}
              modalClass="delete-speciialty-modal"
              actionsClass="container px-4"
              confirmBtnClass="btn-secondary fsize-14 text-white py-2 "
              cancelBtnClass="fsize-14 py-2"
            />
          </>
        ) : (
          !isLoading && (
            <div className="bg-white rounded-4 services-page d-flex justify-content-center align-items-center flex-column m-4 mt-0">
              <EmptyState
                subTitle={shared.noServicesAddedyet}
                ButtonLabel={
                  branches.addBranch.labels.addSepicialtiesAndServices
                }
                handleBtnAction={() => {
                  dispatch(getBranchResponse({}));
                  getSpecialties();
                  setNoAssgiendServicesOnSpecialtyAlert(false);
                  setActiveSection("specialties");
                  setIsAddSpecialtiesAndServicesBTNClicked(true);
                }}
              />
            </div>
          )
        )}
      </>
    );
  };

  const ArrowChange = (value, specialty) => {
    if (value) {
      handleExpandFuntion(value, specialty.id);
      getServicesBySpecialtyId(specialty.realSpecialtyId);
      assignAddedSpecialtyAndServicesFromViewBranchData();
      updateServicesContent();
    } else {
      handleExpandFuntion(value, specialty.id);
      getServicesBySpecialtyId(specialty.realSpecialtyId);
      assignAddedSpecialtyAndServicesFromViewBranchData(); //haya di ely bet8ayar el conttent al outer we haya kamanl aly bet5ali eldata te5tafy
      updateServicesContent();
    }
  };

  const saveAndProcced = () => {
    if (parentProps?.location?.state?.cameFrom) {
      history.push({
        pathname: ROUTE_PATHS.viewBranch.replace(":id", id),
        state: {
          setTabIndex: 1,
        },
      });
    } else {
      proceedToNextStep();
    }
  };

  return (
    <>
      <form
        noValidate
        onSubmit={handleSubmit}
        className="add-specialties-services-section"
      >
        <div className="px-2 px-md-5 bg-white rounded-4 py-4">
          <div className="row">
            <div className="col-12">
              {/*case 1 : empty state*/}
              {renderEmpatyStateSection && renderEmptyState()}{" "}
              {/*case 2 : add new specialty so listing all provider specialties and on click any one go to case 3 */}
              {renderSpecialtiesSection && renderSpecialties()}{" "}
              {/*case 3 : rendering edit specialty so list all provider services on this specialty*/}
              {renderServicesSection && renderServices()}{" "}
              {/*case 4 : rendering branches specialties , services and edit mode of services */}
              {renderAddedServiceSection && viewAddedServices()}{" "}
            </div>
          </div>
        </div>
      </form>
      <AddEditManualSpecialtyModal
        open={showAddEditManualSpecialtyModal}
        setOpen={setShowAddEditManualSpecialtyModal}
        setSelectedSpecialty={setSelectedManualAddedSpecialty}
        selectedSpecialty={selectedManualAddedSpecialty}
        onSuccess={() => setBtnClicked("listSpecialties")}
      />
      <DeleteManualAddedSpecialtyModal
        open={showDeleteManualAddedSpecialtyModal}
        setOpen={setShowDeleteManualAddedSpecialtyModal}
        selectedSpecialty={selectedManualAddedSpecialty}
        onSuccess={() => setBtnClicked("listSpecialties")}
      />
      <AddEditManualServiceModal
        open={showAddEditManualServiceModal}
        setOpen={setShowAddEditManualServiceModal}
        setSelectedService={setSelectedManualAddedService}
        selectedService={selectedManualAddedService}
        choosenSpecialtyId={choosenSpecialtyId}
        onSuccess={() => getServicesBySpecialtyId(choosenSpecialtyId)}
        allowMultiSessions={allowMultiSessions}
      />
      <DeleteManualAddedServiceModal
        open={showDeleteManualAddedServiceModal}
        setOpen={setShowDeleteManualAddedServiceModal}
        selectedService={selectedManualAddedService}
        onSuccess={() => getServicesBySpecialtyId(choosenSpecialtyId)}
      />
    </>
  );
};

export default AddEditServicesDetails;
